[
  {
    "arecod": "GROUND",
    "stoloc": "A01-001-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "35",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-001-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "110",
    "z": "0",
    "volume": "3",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-001-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "185",
    "z": "0",
    "volume": "20",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-001-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "260",
    "z": "0",
    "volume": "90",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-001-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "335",
    "z": "0",
    "volume": "100",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-002-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "35",
    "z": "0",
    "volume": "55",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-002-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "110",
    "z": "0",
    "volume": "67",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-002-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "185",
    "z": "0",
    "volume": "82",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-002-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "260",
    "z": "0",
    "volume": "74",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-002-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "335",
    "z": "0",
    "volume": "47",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-003-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "35",
    "z": "0",
    "volume": "58",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-003-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "110",
    "z": "0",
    "volume": "56",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-003-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "185",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-003-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "260",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-003-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "335",
    "z": "0",
    "volume": "63",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-004-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "35",
    "z": "0",
    "volume": "77",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-004-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "110",
    "z": "0",
    "volume": "88",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-004-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "185",
    "z": "0",
    "volume": "99",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-004-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "260",
    "z": "0",
    "volume": "22",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-004-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "335",
    "z": "0",
    "volume": "11",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-005-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "35",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-005-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "110",
    "z": "0",
    "volume": "3",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-005-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "185",
    "z": "0",
    "volume": "20",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-005-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "260",
    "z": "0",
    "volume": "90",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-005-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "335",
    "z": "0",
    "volume": "100",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-006-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "35",
    "z": "0",
    "volume": "55",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-006-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "110",
    "z": "0",
    "volume": "67",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-006-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "185",
    "z": "0",
    "volume": "82",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-006-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "260",
    "z": "0",
    "volume": "74",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-006-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "335",
    "z": "0",
    "volume": "47",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-007-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "35",
    "z": "0",
    "volume": "58",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-007-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "110",
    "z": "0",
    "volume": "56",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-007-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "185",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-007-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "260",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-007-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "335",
    "z": "0",
    "volume": "85",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-008-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "35",
    "z": "0",
    "volume": "77",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-008-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "110",
    "z": "0",
    "volume": "88",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-008-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "185",
    "z": "0",
    "volume": "99",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-008-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "260",
    "z": "0",
    "volume": "22",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-008-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "335",
    "z": "0",
    "volume": "11",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-009-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "35",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-009-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "110",
    "z": "0",
    "volume": "3",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-009-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "185",
    "z": "0",
    "volume": "20",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-009-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "260",
    "z": "0",
    "volume": "90",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-009-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "335",
    "z": "0",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-010-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "35",
    "z": "0",
    "volume": "55",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-010-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "110",
    "z": "0",
    "volume": "67",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-010-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "185",
    "z": "0",
    "volume": "82",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-010-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "260",
    "z": "0",
    "volume": "74",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-010-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "335",
    "z": "0",
    "volume": "47",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-011-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "35",
    "z": "0",
    "volume": "58",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-011-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "110",
    "z": "0",
    "volume": "56",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-011-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "185",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-011-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "260",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-011-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "335",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-012-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "35",
    "z": "0",
    "volume": "3",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-012-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "110",
    "z": "0",
    "volume": "20",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-012-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "185",
    "z": "0",
    "volume": "90",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-012-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "260",
    "z": "0",
    "volume": "100",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-012-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "335",
    "z": "0",
    "volume": "55",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-013-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "35",
    "z": "0",
    "volume": "67",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-013-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "110",
    "z": "0",
    "volume": "82",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-013-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "185",
    "z": "0",
    "volume": "74",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-013-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "260",
    "z": "0",
    "volume": "47",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-013-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "335",
    "z": "0",
    "volume": "58",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-014-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "35",
    "z": "0",
    "volume": "56",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-014-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "110",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-014-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "185",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-014-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "260",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-014-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "335",
    "z": "0",
    "volume": "3",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-015-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "35",
    "z": "0",
    "volume": "20",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-015-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "110",
    "z": "0",
    "volume": "90",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-015-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "185",
    "z": "0",
    "volume": "100",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-015-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "260",
    "z": "0",
    "volume": "55",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-015-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "335",
    "z": "0",
    "volume": "67",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-016-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "35",
    "z": "0",
    "volume": "82",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-016-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "110",
    "z": "0",
    "volume": "74",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-016-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "185",
    "z": "0",
    "volume": "47",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-016-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "260",
    "z": "0",
    "volume": "58",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-016-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "335",
    "z": "0",
    "volume": "56",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-017-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "35",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-017-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "110",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-017-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "185",
    "z": "0",
    "volume": "23",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-017-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "260",
    "z": "0",
    "volume": "77",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-017-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "335",
    "z": "0",
    "volume": "88",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-018-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "35",
    "z": "0",
    "volume": "99",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-018-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "110",
    "z": "0",
    "volume": "22",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-018-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "185",
    "z": "0",
    "volume": "11",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-018-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "260",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-018-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "335",
    "z": "0",
    "volume": "3",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-019-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "35",
    "z": "0",
    "volume": "20",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-019-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "110",
    "z": "0",
    "volume": "90",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-019-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "185",
    "z": "0",
    "volume": "100",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-019-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "260",
    "z": "0",
    "volume": "55",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-019-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "335",
    "z": "0",
    "volume": "67",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-020-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "35",
    "z": "0",
    "volume": "82",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-020-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "110",
    "z": "0",
    "volume": "74",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-020-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "185",
    "z": "0",
    "volume": "47",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-020-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "260",
    "z": "0",
    "volume": "58",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-020-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "335",
    "z": "0",
    "volume": "56",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-021-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "35",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-021-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "110",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-021-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "185",
    "z": "0",
    "volume": "63",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-021-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "260",
    "z": "0",
    "volume": "77",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-021-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "335",
    "z": "0",
    "volume": "88",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-022-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "35",
    "z": "0",
    "volume": "99",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-022-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "110",
    "z": "0",
    "volume": "22",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-022-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "185",
    "z": "0",
    "volume": "11",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-022-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "260",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-022-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "335",
    "z": "0",
    "volume": "3",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-023-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "35",
    "z": "0",
    "volume": "20",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-023-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "110",
    "z": "0",
    "volume": "90",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-023-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "185",
    "z": "0",
    "volume": "100",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-023-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "260",
    "z": "0",
    "volume": "55",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-023-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "335",
    "z": "0",
    "volume": "67",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-024-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "35",
    "z": "0",
    "volume": "82",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-024-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "110",
    "z": "0",
    "volume": "74",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-024-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "185",
    "z": "0",
    "volume": "47",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-024-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "260",
    "z": "0",
    "volume": "58",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-024-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "335",
    "z": "0",
    "volume": "56",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-025-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "35",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-025-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "110",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-025-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "185",
    "z": "0",
    "volume": "85",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-025-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "260",
    "z": "0",
    "volume": "77",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-025-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "335",
    "z": "0",
    "volume": "88",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-026-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "35",
    "z": "0",
    "volume": "99",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-026-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "110",
    "z": "0",
    "volume": "22",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-026-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "185",
    "z": "0",
    "volume": "11",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-026-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "260",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-026-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "335",
    "z": "0",
    "volume": "3",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-027-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "35",
    "z": "0",
    "volume": "20",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-027-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "110",
    "z": "0",
    "volume": "90",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-027-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "185",
    "z": "0",
    "volume": "100",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-027-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "260",
    "z": "0",
    "volume": "55",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-027-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "335",
    "z": "0",
    "volume": "67",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-028-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "35",
    "z": "0",
    "volume": "82",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-028-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "110",
    "z": "0",
    "volume": "74",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-028-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "185",
    "z": "0",
    "volume": "47",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-028-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "260",
    "z": "0",
    "volume": "58",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-028-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "335",
    "z": "0",
    "volume": "56",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-029-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "35",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-029-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "110",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-029-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "185",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-029-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "260",
    "z": "0",
    "volume": "3",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-029-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "335",
    "z": "0",
    "volume": "20",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-030-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "35",
    "z": "0",
    "volume": "90",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-030-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "110",
    "z": "0",
    "volume": "100",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-030-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "185",
    "z": "0",
    "volume": "55",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-030-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "260",
    "z": "0",
    "volume": "67",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-030-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "335",
    "z": "0",
    "volume": "82",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-031-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "35",
    "z": "0",
    "volume": "74",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-031-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "110",
    "z": "0",
    "volume": "47",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-031-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "185",
    "z": "0",
    "volume": "58",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-031-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "260",
    "z": "0",
    "volume": "56",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-031-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "335",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-032-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "35",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-032-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "110",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-032-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "185",
    "z": "0",
    "volume": "3",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-032-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "260",
    "z": "0",
    "volume": "20",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-032-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "335",
    "z": "0",
    "volume": "90",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-033-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "35",
    "z": "0",
    "volume": "100",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-033-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "110",
    "z": "0",
    "volume": "55",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-033-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "185",
    "z": "0",
    "volume": "67",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-033-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "260",
    "z": "0",
    "volume": "82",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-033-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "335",
    "z": "0",
    "volume": "74",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-034-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "35",
    "z": "0",
    "volume": "47",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-034-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "110",
    "z": "0",
    "volume": "58",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-034-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "185",
    "z": "0",
    "volume": "56",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-034-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "260",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-034-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "335",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-035-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "35",
    "z": "0",
    "volume": "23",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-035-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "110",
    "z": "0",
    "volume": "77",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-035-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "185",
    "z": "0",
    "volume": "88",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-035-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "260",
    "z": "0",
    "volume": "99",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-035-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "335",
    "z": "0",
    "volume": "22",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-036-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "35",
    "z": "0",
    "volume": "11",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-036-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "110",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-036-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "185",
    "z": "0",
    "volume": "3",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-036-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "260",
    "z": "0",
    "volume": "20",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-036-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "335",
    "z": "0",
    "volume": "90",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-037-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "35",
    "z": "0",
    "volume": "100",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-037-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "110",
    "z": "0",
    "volume": "55",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-037-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "185",
    "z": "0",
    "volume": "67",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-037-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "260",
    "z": "0",
    "volume": "82",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-037-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "335",
    "z": "0",
    "volume": "74",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-038-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "35",
    "z": "0",
    "volume": "47",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-038-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "110",
    "z": "0",
    "volume": "58",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-038-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "185",
    "z": "0",
    "volume": "56",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-038-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "260",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-038-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "335",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-039-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "35",
    "z": "0",
    "volume": "63",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-039-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "110",
    "z": "0",
    "volume": "77",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-039-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "185",
    "z": "0",
    "volume": "88",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-039-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "260",
    "z": "0",
    "volume": "99",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-039-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "335",
    "z": "0",
    "volume": "22",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-040-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "35",
    "z": "0",
    "volume": "11",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-040-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "110",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-040-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "185",
    "z": "0",
    "volume": "3",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-040-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "260",
    "z": "0",
    "volume": "20",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-040-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "335",
    "z": "0",
    "volume": "90",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-041-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "35",
    "z": "0",
    "volume": "100",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-041-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "110",
    "z": "0",
    "volume": "55",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-041-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "185",
    "z": "0",
    "volume": "67",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-041-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "260",
    "z": "0",
    "volume": "82",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-041-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "335",
    "z": "0",
    "volume": "74",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-042-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "35",
    "z": "0",
    "volume": "47",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-042-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "110",
    "z": "0",
    "volume": "58",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-042-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "185",
    "z": "0",
    "volume": "56",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-042-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "260",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-042-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "335",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-043-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "35",
    "z": "0",
    "volume": "85",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-043-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "110",
    "z": "0",
    "volume": "77",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-043-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "185",
    "z": "0",
    "volume": "88",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-043-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "260",
    "z": "0",
    "volume": "99",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-043-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "335",
    "z": "0",
    "volume": "22",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-044-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "35",
    "z": "0",
    "volume": "11",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-044-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "110",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-044-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "185",
    "z": "0",
    "volume": "3",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-044-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "260",
    "z": "0",
    "volume": "20",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-044-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "335",
    "z": "0",
    "volume": "90",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-045-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "35",
    "z": "0",
    "volume": "100",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-045-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "110",
    "z": "0",
    "volume": "55",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-045-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "185",
    "z": "0",
    "volume": "67",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-045-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "260",
    "z": "0",
    "volume": "82",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-045-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "335",
    "z": "0",
    "volume": "74",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-046-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "35",
    "z": "0",
    "volume": "47",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-046-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "110",
    "z": "0",
    "volume": "58",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-046-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "185",
    "z": "0",
    "volume": "56",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-046-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "260",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-046-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "335",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-047-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "35",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-047-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "110",
    "z": "0",
    "volume": "3",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-047-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "185",
    "z": "0",
    "volume": "20",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-047-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "260",
    "z": "0",
    "volume": "90",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-047-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "335",
    "z": "0",
    "volume": "100",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-048-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "35",
    "z": "0",
    "volume": "55",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-048-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "110",
    "z": "0",
    "volume": "67",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-048-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "185",
    "z": "0",
    "volume": "82",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-048-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "260",
    "z": "0",
    "volume": "74",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-048-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "335",
    "z": "0",
    "volume": "47",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-049-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "35",
    "z": "0",
    "volume": "58",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-049-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "110",
    "z": "0",
    "volume": "56",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-049-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "185",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-049-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "260",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-049-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "335",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-050-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "35",
    "z": "0",
    "volume": "3",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-050-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "110",
    "z": "0",
    "volume": "20",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-050-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "185",
    "z": "0",
    "volume": "90",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-050-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "260",
    "z": "0",
    "volume": "100",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-050-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "335",
    "z": "0",
    "volume": "55",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-051-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "35",
    "z": "0",
    "volume": "67",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-051-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "110",
    "z": "0",
    "volume": "82",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-051-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "185",
    "z": "0",
    "volume": "74",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-051-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "260",
    "z": "0",
    "volume": "47",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-051-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "335",
    "z": "0",
    "volume": "58",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-052-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "35",
    "z": "0",
    "volume": "56",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-052-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "110",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-052-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "185",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-052-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "260",
    "z": "0",
    "volume": "23",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-052-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "335",
    "z": "0",
    "volume": "77",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-053-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "35",
    "z": "0",
    "volume": "88",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-053-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "110",
    "z": "0",
    "volume": "99",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-053-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "185",
    "z": "0",
    "volume": "22",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-053-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "260",
    "z": "0",
    "volume": "11",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-053-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "335",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-054-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "35",
    "z": "0",
    "volume": "3",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-054-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "110",
    "z": "0",
    "volume": "20",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-054-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "185",
    "z": "0",
    "volume": "90",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-054-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "260",
    "z": "0",
    "volume": "100",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-054-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "335",
    "z": "0",
    "volume": "55",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-055-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "35",
    "z": "0",
    "volume": "67",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-055-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "110",
    "z": "0",
    "volume": "82",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-055-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "185",
    "z": "0",
    "volume": "74",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-055-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "260",
    "z": "0",
    "volume": "47",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-055-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "335",
    "z": "0",
    "volume": "58",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-056-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "35",
    "z": "0",
    "volume": "56",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-056-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "110",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-056-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "185",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-056-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "260",
    "z": "0",
    "volume": "63",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-056-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "335",
    "z": "0",
    "volume": "77",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-057-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "35",
    "z": "0",
    "volume": "88",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-057-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "110",
    "z": "0",
    "volume": "99",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-057-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "185",
    "z": "0",
    "volume": "22",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-057-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "260",
    "z": "0",
    "volume": "11",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-057-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "335",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-058-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "35",
    "z": "0",
    "volume": "3",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-058-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "110",
    "z": "0",
    "volume": "20",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-058-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "185",
    "z": "0",
    "volume": "90",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-058-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "260",
    "z": "0",
    "volume": "100",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-058-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "335",
    "z": "0",
    "volume": "55",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-059-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "35",
    "z": "0",
    "volume": "67",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-059-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "110",
    "z": "0",
    "volume": "82",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-059-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "185",
    "z": "0",
    "volume": "74",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-059-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "260",
    "z": "0",
    "volume": "47",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-059-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "335",
    "z": "0",
    "volume": "58",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-060-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "35",
    "z": "0",
    "volume": "56",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-060-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "110",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-060-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "185",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-060-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "260",
    "z": "0",
    "volume": "85",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-060-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "335",
    "z": "0",
    "volume": "77",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-061-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "35",
    "z": "0",
    "volume": "88",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-061-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "110",
    "z": "0",
    "volume": "99",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-061-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "185",
    "z": "0",
    "volume": "22",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-061-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "260",
    "z": "0",
    "volume": "11",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-061-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "335",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-062-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "35",
    "z": "0",
    "volume": "3",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-062-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "110",
    "z": "0",
    "volume": "20",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-062-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "185",
    "z": "0",
    "volume": "90",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-062-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "260",
    "z": "0",
    "volume": "100",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-062-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "335",
    "z": "0",
    "volume": "55",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-063-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "35",
    "z": "0",
    "volume": "67",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-063-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "110",
    "z": "0",
    "volume": "82",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-063-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "185",
    "z": "0",
    "volume": "74",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-063-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "260",
    "z": "0",
    "volume": "47",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-063-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "335",
    "z": "0",
    "volume": "58",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-064-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "35",
    "z": "0",
    "volume": "56",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-064-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "110",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-064-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "185",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-064-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "260",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-064-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "335",
    "z": "0",
    "volume": "3",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-065-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "35",
    "z": "0",
    "volume": "20",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-065-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "110",
    "z": "0",
    "volume": "90",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-065-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "185",
    "z": "0",
    "volume": "100",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-065-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "260",
    "z": "0",
    "volume": "55",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-065-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "335",
    "z": "0",
    "volume": "67",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-066-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "35",
    "z": "0",
    "volume": "82",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-066-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "110",
    "z": "0",
    "volume": "74",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-066-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "185",
    "z": "0",
    "volume": "47",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-066-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "260",
    "z": "0",
    "volume": "58",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-066-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "335",
    "z": "0",
    "volume": "56",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-067-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "35",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-067-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "110",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-067-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "185",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-067-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "260",
    "z": "0",
    "volume": "3",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-067-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "335",
    "z": "0",
    "volume": "20",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-068-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "35",
    "z": "0",
    "volume": "90",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-068-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "110",
    "z": "0",
    "volume": "100",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-068-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "185",
    "z": "0",
    "volume": "55",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-068-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "260",
    "z": "0",
    "volume": "67",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-068-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "335",
    "z": "0",
    "volume": "82",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-069-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "35",
    "z": "0",
    "volume": "74",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-069-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "110",
    "z": "0",
    "volume": "47",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-069-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "185",
    "z": "0",
    "volume": "58",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-069-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "260",
    "z": "0",
    "volume": "56",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-069-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "335",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A01-070-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "35",
    "z": "0",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-070-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "110",
    "z": "0",
    "volume": "23",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-070-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "185",
    "z": "0",
    "volume": "77",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-070-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "260",
    "z": "0",
    "volume": "88",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A01-070-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "335",
    "z": "0",
    "volume": "99",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-001-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "35",
    "z": "300",
    "volume": "22",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-001-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "110",
    "z": "300",
    "volume": "11",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-001-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "185",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-001-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "260",
    "z": "300",
    "volume": "3",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-001-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "335",
    "z": "300",
    "volume": "20",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-002-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "35",
    "z": "300",
    "volume": "90",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-002-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "110",
    "z": "300",
    "volume": "100",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-002-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "185",
    "z": "300",
    "volume": "55",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-002-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "260",
    "z": "300",
    "volume": "67",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-002-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "335",
    "z": "300",
    "volume": "82",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-003-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "35",
    "z": "300",
    "volume": "74",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-003-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "110",
    "z": "300",
    "volume": "47",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-003-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "185",
    "z": "300",
    "volume": "58",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-003-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "260",
    "z": "300",
    "volume": "56",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-003-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "335",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-004-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "35",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-004-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "110",
    "z": "300",
    "volume": "63",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-004-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "185",
    "z": "300",
    "volume": "77",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-004-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "260",
    "z": "300",
    "volume": "88",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-004-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "335",
    "z": "300",
    "volume": "99",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-005-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "35",
    "z": "300",
    "volume": "22",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-005-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "110",
    "z": "300",
    "volume": "11",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-005-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "185",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-005-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "260",
    "z": "300",
    "volume": "3",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-005-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "335",
    "z": "300",
    "volume": "20",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-006-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "35",
    "z": "300",
    "volume": "90",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-006-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "110",
    "z": "300",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-006-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "185",
    "z": "300",
    "volume": "55",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-006-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "260",
    "z": "300",
    "volume": "67",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-006-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "335",
    "z": "300",
    "volume": "82",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-007-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "35",
    "z": "300",
    "volume": "74",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-007-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "110",
    "z": "300",
    "volume": "47",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-007-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "185",
    "z": "300",
    "volume": "58",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-007-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "260",
    "z": "300",
    "volume": "56",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-007-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "335",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-008-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "35",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-008-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "110",
    "z": "300",
    "volume": "85",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-008-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "185",
    "z": "300",
    "volume": "77",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-008-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "260",
    "z": "300",
    "volume": "88",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-008-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "335",
    "z": "300",
    "volume": "99",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-009-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "35",
    "z": "300",
    "volume": "22",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-009-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "110",
    "z": "300",
    "volume": "11",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-009-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "185",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-009-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "260",
    "z": "300",
    "volume": "3",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-009-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "335",
    "z": "300",
    "volume": "20",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-010-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "35",
    "z": "300",
    "volume": "90",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-010-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "110",
    "z": "300",
    "volume": "100",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-010-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "185",
    "z": "300",
    "volume": "55",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-010-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "260",
    "z": "300",
    "volume": "67",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-010-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "335",
    "z": "300",
    "volume": "82",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-011-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "35",
    "z": "300",
    "volume": "74",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-011-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "110",
    "z": "300",
    "volume": "47",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-011-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "185",
    "z": "300",
    "volume": "58",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-011-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "260",
    "z": "300",
    "volume": "56",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-011-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "335",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-012-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "35",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-012-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "110",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-012-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "185",
    "z": "300",
    "volume": "3",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-012-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "260",
    "z": "300",
    "volume": "20",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-012-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "335",
    "z": "300",
    "volume": "90",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-013-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "35",
    "z": "300",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-013-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "110",
    "z": "300",
    "volume": "55",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-013-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "185",
    "z": "300",
    "volume": "67",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-013-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "260",
    "z": "300",
    "volume": "82",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-013-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "335",
    "z": "300",
    "volume": "74",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-014-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "35",
    "z": "300",
    "volume": "47",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-014-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "110",
    "z": "300",
    "volume": "58",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-014-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "185",
    "z": "300",
    "volume": "56",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-014-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "260",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-014-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "335",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-015-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "35",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-015-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "110",
    "z": "300",
    "volume": "3",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-015-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "185",
    "z": "300",
    "volume": "20",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-015-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "260",
    "z": "300",
    "volume": "90",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-015-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "335",
    "z": "300",
    "volume": "100",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-016-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "35",
    "z": "300",
    "volume": "55",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-016-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "110",
    "z": "300",
    "volume": "67",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-016-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "185",
    "z": "300",
    "volume": "82",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-016-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "260",
    "z": "300",
    "volume": "74",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-016-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "335",
    "z": "300",
    "volume": "47",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-017-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "35",
    "z": "300",
    "volume": "58",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-017-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "110",
    "z": "300",
    "volume": "56",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-017-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "185",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-017-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "260",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-017-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "335",
    "z": "300",
    "volume": "23",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-018-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "35",
    "z": "300",
    "volume": "77",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-018-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "110",
    "z": "300",
    "volume": "88",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-018-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "185",
    "z": "300",
    "volume": "99",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-018-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "260",
    "z": "300",
    "volume": "22",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-018-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "335",
    "z": "300",
    "volume": "11",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-019-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "35",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-019-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "110",
    "z": "300",
    "volume": "3",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-019-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "185",
    "z": "300",
    "volume": "20",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-019-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "260",
    "z": "300",
    "volume": "90",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-019-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "335",
    "z": "300",
    "volume": "100",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-020-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "35",
    "z": "300",
    "volume": "55",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-020-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "110",
    "z": "300",
    "volume": "67",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-020-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "185",
    "z": "300",
    "volume": "82",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-020-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "260",
    "z": "300",
    "volume": "74",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-020-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "335",
    "z": "300",
    "volume": "47",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-021-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "35",
    "z": "300",
    "volume": "58",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-021-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "110",
    "z": "300",
    "volume": "56",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-021-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "185",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-021-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "260",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-021-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "335",
    "z": "300",
    "volume": "63",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-022-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "35",
    "z": "300",
    "volume": "77",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-022-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "110",
    "z": "300",
    "volume": "88",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-022-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "185",
    "z": "300",
    "volume": "99",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-022-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "260",
    "z": "300",
    "volume": "22",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-022-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "335",
    "z": "300",
    "volume": "11",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-023-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "35",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-023-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "110",
    "z": "300",
    "volume": "3",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-023-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "185",
    "z": "300",
    "volume": "20",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-023-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "260",
    "z": "300",
    "volume": "90",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-023-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "335",
    "z": "300",
    "volume": "100",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-024-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "35",
    "z": "300",
    "volume": "55",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-024-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "110",
    "z": "300",
    "volume": "67",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-024-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "185",
    "z": "300",
    "volume": "82",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-024-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "260",
    "z": "300",
    "volume": "74",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-024-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "335",
    "z": "300",
    "volume": "47",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-025-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "35",
    "z": "300",
    "volume": "58",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-025-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "110",
    "z": "300",
    "volume": "56",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-025-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "185",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-025-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "260",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-025-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "335",
    "z": "300",
    "volume": "85",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-026-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "35",
    "z": "300",
    "volume": "77",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-026-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "110",
    "z": "300",
    "volume": "88",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-026-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "185",
    "z": "300",
    "volume": "99",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-026-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "260",
    "z": "300",
    "volume": "22",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-026-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "335",
    "z": "300",
    "volume": "11",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-027-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "35",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-027-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "110",
    "z": "300",
    "volume": "3",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-027-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "185",
    "z": "300",
    "volume": "20",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-027-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "260",
    "z": "300",
    "volume": "90",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-027-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "335",
    "z": "300",
    "volume": "100",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-028-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "35",
    "z": "300",
    "volume": "55",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-028-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "110",
    "z": "300",
    "volume": "67",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-028-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "185",
    "z": "300",
    "volume": "82",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-028-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "260",
    "z": "300",
    "volume": "74",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-028-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "335",
    "z": "300",
    "volume": "47",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-029-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "35",
    "z": "300",
    "volume": "58",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-029-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "110",
    "z": "300",
    "volume": "56",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-029-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "185",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-029-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "260",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-029-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "335",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-030-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "35",
    "z": "300",
    "volume": "3",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-030-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "110",
    "z": "300",
    "volume": "20",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-030-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "185",
    "z": "300",
    "volume": "90",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-030-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "260",
    "z": "300",
    "volume": "100",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-030-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "335",
    "z": "300",
    "volume": "55",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-031-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "35",
    "z": "300",
    "volume": "67",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-031-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "110",
    "z": "300",
    "volume": "82",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-031-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "185",
    "z": "300",
    "volume": "74",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-031-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "260",
    "z": "300",
    "volume": "47",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-031-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "335",
    "z": "300",
    "volume": "58",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-032-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "35",
    "z": "300",
    "volume": "56",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-032-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "110",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-032-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "185",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-032-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "260",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-032-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "335",
    "z": "300",
    "volume": "3",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-033-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "35",
    "z": "300",
    "volume": "20",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-033-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "110",
    "z": "300",
    "volume": "90",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-033-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "185",
    "z": "300",
    "volume": "100",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-033-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "260",
    "z": "300",
    "volume": "55",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-033-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "335",
    "z": "300",
    "volume": "67",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-034-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "35",
    "z": "300",
    "volume": "82",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-034-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "110",
    "z": "300",
    "volume": "74",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-034-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "185",
    "z": "300",
    "volume": "47",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-034-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "260",
    "z": "300",
    "volume": "58",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-034-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "335",
    "z": "300",
    "volume": "56",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-035-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "35",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-035-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "110",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-035-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "185",
    "z": "300",
    "volume": "23",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-035-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "260",
    "z": "300",
    "volume": "77",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-035-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "335",
    "z": "300",
    "volume": "88",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-036-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "35",
    "z": "300",
    "volume": "99",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-036-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "110",
    "z": "300",
    "volume": "22",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-036-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "185",
    "z": "300",
    "volume": "11",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-036-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "260",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-036-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "335",
    "z": "300",
    "volume": "3",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-037-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "35",
    "z": "300",
    "volume": "20",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-037-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "110",
    "z": "300",
    "volume": "90",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-037-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "185",
    "z": "300",
    "volume": "100",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-037-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "260",
    "z": "300",
    "volume": "55",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-037-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "335",
    "z": "300",
    "volume": "67",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-038-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "35",
    "z": "300",
    "volume": "82",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-038-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "110",
    "z": "300",
    "volume": "74",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-038-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "185",
    "z": "300",
    "volume": "47",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-038-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "260",
    "z": "300",
    "volume": "58",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-038-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "335",
    "z": "300",
    "volume": "56",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-039-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "35",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-039-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "110",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-039-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "185",
    "z": "300",
    "volume": "63",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-039-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "260",
    "z": "300",
    "volume": "77",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-039-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "335",
    "z": "300",
    "volume": "88",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-040-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "35",
    "z": "300",
    "volume": "99",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-040-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "110",
    "z": "300",
    "volume": "22",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-040-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "185",
    "z": "300",
    "volume": "11",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-040-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "260",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-040-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "335",
    "z": "300",
    "volume": "3",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-041-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "35",
    "z": "300",
    "volume": "20",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-041-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "110",
    "z": "300",
    "volume": "90",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-041-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "185",
    "z": "300",
    "volume": "100",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-041-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "260",
    "z": "300",
    "volume": "55",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-041-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "335",
    "z": "300",
    "volume": "67",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-042-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "35",
    "z": "300",
    "volume": "82",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-042-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "110",
    "z": "300",
    "volume": "74",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-042-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "185",
    "z": "300",
    "volume": "47",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-042-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "260",
    "z": "300",
    "volume": "58",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-042-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "335",
    "z": "300",
    "volume": "56",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-043-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "35",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-043-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "110",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-043-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "185",
    "z": "300",
    "volume": "85",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-043-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "260",
    "z": "300",
    "volume": "77",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-043-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "335",
    "z": "300",
    "volume": "88",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-044-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "35",
    "z": "300",
    "volume": "99",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-044-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "110",
    "z": "300",
    "volume": "22",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-044-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "185",
    "z": "300",
    "volume": "11",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-044-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "260",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-044-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "335",
    "z": "300",
    "volume": "3",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-045-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "35",
    "z": "300",
    "volume": "20",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-045-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "110",
    "z": "300",
    "volume": "90",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-045-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "185",
    "z": "300",
    "volume": "100",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-045-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "260",
    "z": "300",
    "volume": "55",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-045-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "335",
    "z": "300",
    "volume": "67",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-046-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "35",
    "z": "300",
    "volume": "82",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-046-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "110",
    "z": "300",
    "volume": "74",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-046-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "185",
    "z": "300",
    "volume": "47",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-046-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "260",
    "z": "300",
    "volume": "58",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-046-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "335",
    "z": "300",
    "volume": "56",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-047-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "35",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-047-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "110",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-047-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "185",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-047-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "260",
    "z": "300",
    "volume": "3",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-047-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "335",
    "z": "300",
    "volume": "20",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-048-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "35",
    "z": "300",
    "volume": "90",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-048-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "110",
    "z": "300",
    "volume": "100",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-048-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "185",
    "z": "300",
    "volume": "55",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-048-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "260",
    "z": "300",
    "volume": "67",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-048-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "335",
    "z": "300",
    "volume": "82",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-049-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "35",
    "z": "300",
    "volume": "74",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-049-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "110",
    "z": "300",
    "volume": "47",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-049-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "185",
    "z": "300",
    "volume": "58",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-049-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "260",
    "z": "300",
    "volume": "56",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-049-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "335",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-050-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "35",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-050-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "110",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-050-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "185",
    "z": "300",
    "volume": "3",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-050-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "260",
    "z": "300",
    "volume": "20",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-050-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "335",
    "z": "300",
    "volume": "90",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-051-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "35",
    "z": "300",
    "volume": "100",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-051-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "110",
    "z": "300",
    "volume": "55",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-051-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "185",
    "z": "300",
    "volume": "67",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-051-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "260",
    "z": "300",
    "volume": "82",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-051-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "335",
    "z": "300",
    "volume": "74",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-052-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "35",
    "z": "300",
    "volume": "47",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-052-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "110",
    "z": "300",
    "volume": "58",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-052-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "185",
    "z": "300",
    "volume": "56",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-052-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "260",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-052-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "335",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-053-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "35",
    "z": "300",
    "volume": "23",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-053-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "110",
    "z": "300",
    "volume": "77",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-053-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "185",
    "z": "300",
    "volume": "88",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-053-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "260",
    "z": "300",
    "volume": "99",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-053-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "335",
    "z": "300",
    "volume": "22",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-054-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "35",
    "z": "300",
    "volume": "11",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-054-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "110",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-054-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "185",
    "z": "300",
    "volume": "3",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-054-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "260",
    "z": "300",
    "volume": "20",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-054-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "335",
    "z": "300",
    "volume": "90",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-055-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "35",
    "z": "300",
    "volume": "100",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-055-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "110",
    "z": "300",
    "volume": "55",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-055-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "185",
    "z": "300",
    "volume": "67",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-055-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "260",
    "z": "300",
    "volume": "82",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-055-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "335",
    "z": "300",
    "volume": "74",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-056-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "35",
    "z": "300",
    "volume": "47",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-056-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "110",
    "z": "300",
    "volume": "58",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-056-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "185",
    "z": "300",
    "volume": "56",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-056-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "260",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-056-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "335",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-057-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "35",
    "z": "300",
    "volume": "63",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-057-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "110",
    "z": "300",
    "volume": "77",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-057-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "185",
    "z": "300",
    "volume": "88",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-057-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "260",
    "z": "300",
    "volume": "99",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-057-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "335",
    "z": "300",
    "volume": "22",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-058-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "35",
    "z": "300",
    "volume": "11",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-058-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "110",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-058-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "185",
    "z": "300",
    "volume": "3",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-058-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "260",
    "z": "300",
    "volume": "20",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-058-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "335",
    "z": "300",
    "volume": "90",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-059-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "35",
    "z": "300",
    "volume": "100",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-059-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "110",
    "z": "300",
    "volume": "55",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-059-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "185",
    "z": "300",
    "volume": "67",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-059-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "260",
    "z": "300",
    "volume": "82",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-059-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "335",
    "z": "300",
    "volume": "74",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-060-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "35",
    "z": "300",
    "volume": "47",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-060-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "110",
    "z": "300",
    "volume": "58",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-060-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "185",
    "z": "300",
    "volume": "56",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-060-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "260",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-060-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "335",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-061-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "35",
    "z": "300",
    "volume": "85",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-061-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "110",
    "z": "300",
    "volume": "77",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-061-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "185",
    "z": "300",
    "volume": "88",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-061-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "260",
    "z": "300",
    "volume": "99",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-061-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "335",
    "z": "300",
    "volume": "22",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-062-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "35",
    "z": "300",
    "volume": "11",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-062-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "110",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-062-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "185",
    "z": "300",
    "volume": "3",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-062-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "260",
    "z": "300",
    "volume": "20",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-062-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "335",
    "z": "300",
    "volume": "90",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-063-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "35",
    "z": "300",
    "volume": "100",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-063-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "110",
    "z": "300",
    "volume": "55",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-063-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "185",
    "z": "300",
    "volume": "67",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-063-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "260",
    "z": "300",
    "volume": "82",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-063-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "335",
    "z": "300",
    "volume": "74",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-064-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "35",
    "z": "300",
    "volume": "47",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-064-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "110",
    "z": "300",
    "volume": "58",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-064-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "185",
    "z": "300",
    "volume": "56",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-064-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "260",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-064-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "335",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-065-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "35",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-065-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "110",
    "z": "300",
    "volume": "3",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-065-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "185",
    "z": "300",
    "volume": "20",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-065-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "260",
    "z": "300",
    "volume": "90",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-065-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "335",
    "z": "300",
    "volume": "100",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-066-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "35",
    "z": "300",
    "volume": "55",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-066-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "110",
    "z": "300",
    "volume": "67",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-066-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "185",
    "z": "300",
    "volume": "82",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-066-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "260",
    "z": "300",
    "volume": "74",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-066-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "335",
    "z": "300",
    "volume": "47",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-067-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "35",
    "z": "300",
    "volume": "58",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-067-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "110",
    "z": "300",
    "volume": "56",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-067-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "185",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-067-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "260",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-067-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "335",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-068-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "35",
    "z": "300",
    "volume": "3",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-068-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "110",
    "z": "300",
    "volume": "20",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-068-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "185",
    "z": "300",
    "volume": "90",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-068-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "260",
    "z": "300",
    "volume": "100",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-068-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "335",
    "z": "300",
    "volume": "55",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-069-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "35",
    "z": "300",
    "volume": "67",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-069-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "110",
    "z": "300",
    "volume": "82",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-069-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "185",
    "z": "300",
    "volume": "74",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-069-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "260",
    "z": "300",
    "volume": "47",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-069-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "335",
    "z": "300",
    "volume": "58",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A02-070-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "35",
    "z": "300",
    "volume": "56",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-070-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "110",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-070-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "185",
    "z": "300",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-070-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "260",
    "z": "300",
    "volume": "23",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A02-070-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "335",
    "z": "300",
    "volume": "77",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-001-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "35",
    "z": "370",
    "volume": "88",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-001-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "110",
    "z": "370",
    "volume": "99",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-001-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "185",
    "z": "370",
    "volume": "22",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-001-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "260",
    "z": "370",
    "volume": "11",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-001-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "335",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-002-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "35",
    "z": "370",
    "volume": "3",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-002-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "110",
    "z": "370",
    "volume": "20",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-002-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "185",
    "z": "370",
    "volume": "90",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-002-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "260",
    "z": "370",
    "volume": "100",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-002-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "335",
    "z": "370",
    "volume": "55",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-003-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "35",
    "z": "370",
    "volume": "67",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-003-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "110",
    "z": "370",
    "volume": "82",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-003-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "185",
    "z": "370",
    "volume": "74",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-003-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "260",
    "z": "370",
    "volume": "47",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-003-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "335",
    "z": "370",
    "volume": "58",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-004-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "35",
    "z": "370",
    "volume": "56",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-004-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "110",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-004-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "185",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-004-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "260",
    "z": "370",
    "volume": "63",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-004-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "335",
    "z": "370",
    "volume": "77",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-005-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "35",
    "z": "370",
    "volume": "88",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-005-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "110",
    "z": "370",
    "volume": "99",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-005-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "185",
    "z": "370",
    "volume": "22",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-005-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "260",
    "z": "370",
    "volume": "11",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-005-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "335",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-006-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "35",
    "z": "370",
    "volume": "3",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-006-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "110",
    "z": "370",
    "volume": "20",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-006-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "185",
    "z": "370",
    "volume": "90",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-006-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "260",
    "z": "370",
    "volume": "100",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-006-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "335",
    "z": "370",
    "volume": "55",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-007-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "35",
    "z": "370",
    "volume": "67",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-007-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "110",
    "z": "370",
    "volume": "82",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-007-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "185",
    "z": "370",
    "volume": "74",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-007-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "260",
    "z": "370",
    "volume": "47",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-007-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "335",
    "z": "370",
    "volume": "58",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-008-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "35",
    "z": "370",
    "volume": "56",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-008-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "110",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-008-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "185",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-008-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "260",
    "z": "370",
    "volume": "85",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-008-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "335",
    "z": "370",
    "volume": "77",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-009-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "35",
    "z": "370",
    "volume": "88",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-009-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "110",
    "z": "370",
    "volume": "99",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-009-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "185",
    "z": "370",
    "volume": "22",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-009-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "260",
    "z": "370",
    "volume": "11",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-009-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "335",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-010-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "35",
    "z": "370",
    "volume": "3",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-010-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "110",
    "z": "370",
    "volume": "20",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-010-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "185",
    "z": "370",
    "volume": "90",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-010-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "260",
    "z": "370",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-010-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "335",
    "z": "370",
    "volume": "55",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-011-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "35",
    "z": "370",
    "volume": "67",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-011-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "110",
    "z": "370",
    "volume": "82",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-011-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "185",
    "z": "370",
    "volume": "74",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-011-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "260",
    "z": "370",
    "volume": "47",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-011-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "335",
    "z": "370",
    "volume": "58",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-012-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "35",
    "z": "370",
    "volume": "56",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-012-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "110",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-012-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "185",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-012-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "260",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-012-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "335",
    "z": "370",
    "volume": "3",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-013-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "35",
    "z": "370",
    "volume": "20",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-013-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "110",
    "z": "370",
    "volume": "90",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-013-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "185",
    "z": "370",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-013-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "260",
    "z": "370",
    "volume": "55",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-013-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "335",
    "z": "370",
    "volume": "67",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-014-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "35",
    "z": "370",
    "volume": "82",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-014-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "110",
    "z": "370",
    "volume": "74",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-014-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "185",
    "z": "370",
    "volume": "47",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-014-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "260",
    "z": "370",
    "volume": "58",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-014-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "335",
    "z": "370",
    "volume": "56",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-015-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "35",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-015-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "110",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-015-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "185",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-015-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "260",
    "z": "370",
    "volume": "3",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-015-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "335",
    "z": "370",
    "volume": "20",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-016-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "35",
    "z": "370",
    "volume": "90",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-016-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "110",
    "z": "370",
    "volume": "100",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-016-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "185",
    "z": "370",
    "volume": "55",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-016-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "260",
    "z": "370",
    "volume": "67",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-016-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "335",
    "z": "370",
    "volume": "82",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-017-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "35",
    "z": "370",
    "volume": "74",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-017-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "110",
    "z": "370",
    "volume": "47",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-017-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "185",
    "z": "370",
    "volume": "58",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-017-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "260",
    "z": "370",
    "volume": "56",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-017-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "335",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-018-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "35",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-018-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "110",
    "z": "370",
    "volume": "23",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-018-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "185",
    "z": "370",
    "volume": "77",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-018-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "260",
    "z": "370",
    "volume": "88",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-018-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "335",
    "z": "370",
    "volume": "99",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-019-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "35",
    "z": "370",
    "volume": "22",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-019-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "110",
    "z": "370",
    "volume": "11",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-019-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "185",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-019-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "260",
    "z": "370",
    "volume": "3",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-019-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "335",
    "z": "370",
    "volume": "20",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-020-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "35",
    "z": "370",
    "volume": "90",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-020-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "110",
    "z": "370",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-020-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "185",
    "z": "370",
    "volume": "55",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-020-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "260",
    "z": "370",
    "volume": "67",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-020-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "335",
    "z": "370",
    "volume": "82",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-021-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "35",
    "z": "370",
    "volume": "74",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-021-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "110",
    "z": "370",
    "volume": "47",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-021-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "185",
    "z": "370",
    "volume": "58",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-021-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "260",
    "z": "370",
    "volume": "56",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-021-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "335",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-022-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "35",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-022-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "110",
    "z": "370",
    "volume": "63",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-022-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "185",
    "z": "370",
    "volume": "77",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-022-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "260",
    "z": "370",
    "volume": "88",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-022-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "335",
    "z": "370",
    "volume": "99",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-023-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "35",
    "z": "370",
    "volume": "22",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-023-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "110",
    "z": "370",
    "volume": "11",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-023-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "185",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-023-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "260",
    "z": "370",
    "volume": "3",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-023-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "335",
    "z": "370",
    "volume": "20",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-024-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "35",
    "z": "370",
    "volume": "90",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-024-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "110",
    "z": "370",
    "volume": "100",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-024-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "185",
    "z": "370",
    "volume": "55",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-024-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "260",
    "z": "370",
    "volume": "67",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-024-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "335",
    "z": "370",
    "volume": "82",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-025-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "35",
    "z": "370",
    "volume": "74",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-025-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "110",
    "z": "370",
    "volume": "47",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-025-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "185",
    "z": "370",
    "volume": "58",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-025-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "260",
    "z": "370",
    "volume": "56",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-025-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "335",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-026-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "35",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-026-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "110",
    "z": "370",
    "volume": "85",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-026-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "185",
    "z": "370",
    "volume": "77",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-026-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "260",
    "z": "370",
    "volume": "88",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-026-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "335",
    "z": "370",
    "volume": "99",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-027-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "35",
    "z": "370",
    "volume": "22",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-027-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "110",
    "z": "370",
    "volume": "11",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-027-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "185",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-027-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "260",
    "z": "370",
    "volume": "3",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-027-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "335",
    "z": "370",
    "volume": "20",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-028-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "35",
    "z": "370",
    "volume": "90",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-028-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "110",
    "z": "370",
    "volume": "100",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-028-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "185",
    "z": "370",
    "volume": "55",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-028-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "260",
    "z": "370",
    "volume": "67",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-028-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "335",
    "z": "370",
    "volume": "82",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-029-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "35",
    "z": "370",
    "volume": "74",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-029-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "110",
    "z": "370",
    "volume": "47",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-029-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "185",
    "z": "370",
    "volume": "58",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-029-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "260",
    "z": "370",
    "volume": "56",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-029-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "335",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-030-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "35",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-030-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "110",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-030-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "185",
    "z": "370",
    "volume": "3",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-030-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "260",
    "z": "370",
    "volume": "20",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-030-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "335",
    "z": "370",
    "volume": "90",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-031-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "35",
    "z": "370",
    "volume": "100",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-031-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "110",
    "z": "370",
    "volume": "55",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-031-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "185",
    "z": "370",
    "volume": "67",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-031-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "260",
    "z": "370",
    "volume": "82",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-031-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "335",
    "z": "370",
    "volume": "74",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-032-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "35",
    "z": "370",
    "volume": "47",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-032-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "110",
    "z": "370",
    "volume": "58",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-032-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "185",
    "z": "370",
    "volume": "56",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-032-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "260",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-032-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "335",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-033-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "35",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-033-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "110",
    "z": "370",
    "volume": "3",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-033-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "185",
    "z": "370",
    "volume": "20",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-033-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "260",
    "z": "370",
    "volume": "90",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-033-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "335",
    "z": "370",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-034-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "35",
    "z": "370",
    "volume": "55",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-034-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "110",
    "z": "370",
    "volume": "67",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-034-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "185",
    "z": "370",
    "volume": "82",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-034-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "260",
    "z": "370",
    "volume": "74",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-034-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "335",
    "z": "370",
    "volume": "47",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-035-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "35",
    "z": "370",
    "volume": "58",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-035-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "110",
    "z": "370",
    "volume": "56",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-035-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "185",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-035-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "260",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-035-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "335",
    "z": "370",
    "volume": "23",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-036-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "35",
    "z": "370",
    "volume": "77",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-036-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "110",
    "z": "370",
    "volume": "88",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-036-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "185",
    "z": "370",
    "volume": "99",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-036-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "260",
    "z": "370",
    "volume": "22",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-036-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "335",
    "z": "370",
    "volume": "11",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-037-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "35",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-037-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "110",
    "z": "370",
    "volume": "3",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-037-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "185",
    "z": "370",
    "volume": "20",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-037-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "260",
    "z": "370",
    "volume": "90",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-037-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "335",
    "z": "370",
    "volume": "100",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-038-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "35",
    "z": "370",
    "volume": "55",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-038-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "110",
    "z": "370",
    "volume": "67",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-038-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "185",
    "z": "370",
    "volume": "82",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-038-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "260",
    "z": "370",
    "volume": "74",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-038-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "335",
    "z": "370",
    "volume": "47",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-039-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "35",
    "z": "370",
    "volume": "58",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-039-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "110",
    "z": "370",
    "volume": "56",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-039-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "185",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-039-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "260",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-039-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "335",
    "z": "370",
    "volume": "63",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-040-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "35",
    "z": "370",
    "volume": "77",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-040-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "110",
    "z": "370",
    "volume": "88",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-040-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "185",
    "z": "370",
    "volume": "99",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-040-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "260",
    "z": "370",
    "volume": "22",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-040-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "335",
    "z": "370",
    "volume": "11",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-041-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "35",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-041-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "110",
    "z": "370",
    "volume": "3",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-041-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "185",
    "z": "370",
    "volume": "20",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-041-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "260",
    "z": "370",
    "volume": "90",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-041-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "335",
    "z": "370",
    "volume": "100",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-042-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "35",
    "z": "370",
    "volume": "55",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-042-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "110",
    "z": "370",
    "volume": "67",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-042-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "185",
    "z": "370",
    "volume": "82",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-042-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "260",
    "z": "370",
    "volume": "74",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-042-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "335",
    "z": "370",
    "volume": "47",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-043-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "35",
    "z": "370",
    "volume": "58",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-043-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "110",
    "z": "370",
    "volume": "56",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-043-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "185",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-043-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "260",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-043-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "335",
    "z": "370",
    "volume": "85",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-044-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "35",
    "z": "370",
    "volume": "77",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-044-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "110",
    "z": "370",
    "volume": "88",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-044-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "185",
    "z": "370",
    "volume": "99",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-044-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "260",
    "z": "370",
    "volume": "22",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-044-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "335",
    "z": "370",
    "volume": "11",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-045-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "35",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-045-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "110",
    "z": "370",
    "volume": "3",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-045-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "185",
    "z": "370",
    "volume": "20",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-045-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "260",
    "z": "370",
    "volume": "90",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-045-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "335",
    "z": "370",
    "volume": "100",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-046-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "35",
    "z": "370",
    "volume": "55",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-046-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "110",
    "z": "370",
    "volume": "67",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-046-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "185",
    "z": "370",
    "volume": "82",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-046-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "260",
    "z": "370",
    "volume": "74",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-046-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "335",
    "z": "370",
    "volume": "47",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-047-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "35",
    "z": "370",
    "volume": "58",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-047-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "110",
    "z": "370",
    "volume": "56",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-047-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "185",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-047-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "260",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-047-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "335",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-048-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "35",
    "z": "370",
    "volume": "3",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-048-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "110",
    "z": "370",
    "volume": "20",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-048-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "185",
    "z": "370",
    "volume": "90",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-048-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "260",
    "z": "370",
    "volume": "100",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-048-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "335",
    "z": "370",
    "volume": "55",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-049-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "35",
    "z": "370",
    "volume": "67",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-049-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "110",
    "z": "370",
    "volume": "82",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-049-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "185",
    "z": "370",
    "volume": "74",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-049-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "260",
    "z": "370",
    "volume": "47",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-049-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "335",
    "z": "370",
    "volume": "58",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-050-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "35",
    "z": "370",
    "volume": "56",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-050-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "110",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-050-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "185",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-050-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "260",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-050-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "335",
    "z": "370",
    "volume": "3",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-051-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "35",
    "z": "370",
    "volume": "20",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-051-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "110",
    "z": "370",
    "volume": "90",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-051-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "185",
    "z": "370",
    "volume": "100",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-051-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "260",
    "z": "370",
    "volume": "55",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-051-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "335",
    "z": "370",
    "volume": "67",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-052-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "35",
    "z": "370",
    "volume": "82",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-052-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "110",
    "z": "370",
    "volume": "74",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-052-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "185",
    "z": "370",
    "volume": "47",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-052-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "260",
    "z": "370",
    "volume": "58",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-052-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "335",
    "z": "370",
    "volume": "56",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-053-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "35",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-053-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "110",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-053-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "185",
    "z": "370",
    "volume": "23",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-053-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "260",
    "z": "370",
    "volume": "77",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-053-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "335",
    "z": "370",
    "volume": "88",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-054-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "35",
    "z": "370",
    "volume": "99",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-054-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "110",
    "z": "370",
    "volume": "22",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-054-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "185",
    "z": "370",
    "volume": "11",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-054-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "260",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-054-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "335",
    "z": "370",
    "volume": "3",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-055-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "35",
    "z": "370",
    "volume": "20",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-055-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "110",
    "z": "370",
    "volume": "90",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-055-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "185",
    "z": "370",
    "volume": "100",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-055-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "260",
    "z": "370",
    "volume": "55",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-055-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "335",
    "z": "370",
    "volume": "67",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-056-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "35",
    "z": "370",
    "volume": "82",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-056-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "110",
    "z": "370",
    "volume": "74",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-056-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "185",
    "z": "370",
    "volume": "47",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-056-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "260",
    "z": "370",
    "volume": "58",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-056-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "335",
    "z": "370",
    "volume": "56",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-057-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "35",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-057-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "110",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-057-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "185",
    "z": "370",
    "volume": "63",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-057-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "260",
    "z": "370",
    "volume": "77",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-057-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "335",
    "z": "370",
    "volume": "88",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-058-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "35",
    "z": "370",
    "volume": "99",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-058-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "110",
    "z": "370",
    "volume": "22",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-058-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "185",
    "z": "370",
    "volume": "11",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-058-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "260",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-058-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "335",
    "z": "370",
    "volume": "3",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-059-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "35",
    "z": "370",
    "volume": "20",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-059-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "110",
    "z": "370",
    "volume": "90",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-059-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "185",
    "z": "370",
    "volume": "100",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-059-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "260",
    "z": "370",
    "volume": "55",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-059-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "335",
    "z": "370",
    "volume": "67",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-060-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "35",
    "z": "370",
    "volume": "82",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-060-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "110",
    "z": "370",
    "volume": "74",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-060-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "185",
    "z": "370",
    "volume": "47",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-060-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "260",
    "z": "370",
    "volume": "58",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-060-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "335",
    "z": "370",
    "volume": "56",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-061-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "35",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-061-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "110",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-061-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "185",
    "z": "370",
    "volume": "85",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-061-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "260",
    "z": "370",
    "volume": "77",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-061-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "335",
    "z": "370",
    "volume": "88",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-062-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "35",
    "z": "370",
    "volume": "99",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-062-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "110",
    "z": "370",
    "volume": "22",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-062-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "185",
    "z": "370",
    "volume": "11",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-062-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "260",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-062-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "335",
    "z": "370",
    "volume": "3",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-063-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "35",
    "z": "370",
    "volume": "20",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-063-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "110",
    "z": "370",
    "volume": "90",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-063-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "185",
    "z": "370",
    "volume": "100",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-063-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "260",
    "z": "370",
    "volume": "55",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-063-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "335",
    "z": "370",
    "volume": "67",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-064-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "35",
    "z": "370",
    "volume": "82",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-064-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "110",
    "z": "370",
    "volume": "74",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-064-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "185",
    "z": "370",
    "volume": "47",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-064-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "260",
    "z": "370",
    "volume": "58",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-064-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "335",
    "z": "370",
    "volume": "56",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-065-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "35",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-065-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "110",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-065-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "185",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-065-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "260",
    "z": "370",
    "volume": "3",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-065-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "335",
    "z": "370",
    "volume": "20",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-066-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "35",
    "z": "370",
    "volume": "90",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-066-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "110",
    "z": "370",
    "volume": "100",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-066-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "185",
    "z": "370",
    "volume": "55",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-066-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "260",
    "z": "370",
    "volume": "67",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-066-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "335",
    "z": "370",
    "volume": "82",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-067-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "35",
    "z": "370",
    "volume": "74",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-067-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "110",
    "z": "370",
    "volume": "47",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-067-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "185",
    "z": "370",
    "volume": "58",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-067-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "260",
    "z": "370",
    "volume": "56",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-067-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "335",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-068-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "35",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-068-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "110",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-068-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "185",
    "z": "370",
    "volume": "3",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-068-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "260",
    "z": "370",
    "volume": "20",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-068-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "335",
    "z": "370",
    "volume": "90",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-069-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "35",
    "z": "370",
    "volume": "100",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-069-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "110",
    "z": "370",
    "volume": "55",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-069-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "185",
    "z": "370",
    "volume": "67",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-069-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "260",
    "z": "370",
    "volume": "82",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-069-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "335",
    "z": "370",
    "volume": "74",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A03-070-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "35",
    "z": "370",
    "volume": "47",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-070-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "110",
    "z": "370",
    "volume": "58",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-070-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "185",
    "z": "370",
    "volume": "56",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-070-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "260",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A03-070-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "335",
    "z": "370",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-001-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "35",
    "z": "670",
    "volume": "23",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-001-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "110",
    "z": "670",
    "volume": "77",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-001-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "185",
    "z": "670",
    "volume": "88",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-001-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "260",
    "z": "670",
    "volume": "99",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-001-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "335",
    "z": "670",
    "volume": "22",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-002-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "35",
    "z": "670",
    "volume": "11",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-002-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "110",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-002-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "185",
    "z": "670",
    "volume": "3",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-002-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "260",
    "z": "670",
    "volume": "20",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-002-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "335",
    "z": "670",
    "volume": "90",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-003-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "35",
    "z": "670",
    "volume": "100",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-003-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "110",
    "z": "670",
    "volume": "55",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-003-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "185",
    "z": "670",
    "volume": "67",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-003-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "260",
    "z": "670",
    "volume": "82",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-003-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "335",
    "z": "670",
    "volume": "74",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-004-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "35",
    "z": "670",
    "volume": "47",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-004-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "110",
    "z": "670",
    "volume": "58",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-004-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "185",
    "z": "670",
    "volume": "56",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-004-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "260",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-004-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "335",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-005-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "35",
    "z": "670",
    "volume": "63",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-005-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "110",
    "z": "670",
    "volume": "77",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-005-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "185",
    "z": "670",
    "volume": "88",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-005-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "260",
    "z": "670",
    "volume": "99",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-005-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "335",
    "z": "670",
    "volume": "22",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-006-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "35",
    "z": "670",
    "volume": "11",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-006-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "110",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-006-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "185",
    "z": "670",
    "volume": "3",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-006-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "260",
    "z": "670",
    "volume": "20",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-006-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "335",
    "z": "670",
    "volume": "90",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-007-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "35",
    "z": "670",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-007-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "110",
    "z": "670",
    "volume": "55",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-007-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "185",
    "z": "670",
    "volume": "67",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-007-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "260",
    "z": "670",
    "volume": "82",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-007-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "335",
    "z": "670",
    "volume": "74",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-008-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "35",
    "z": "670",
    "volume": "47",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-008-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "110",
    "z": "670",
    "volume": "58",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-008-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "185",
    "z": "670",
    "volume": "56",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-008-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "260",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-008-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "335",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-009-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "35",
    "z": "670",
    "volume": "85",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-009-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "110",
    "z": "670",
    "volume": "77",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-009-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "185",
    "z": "670",
    "volume": "88",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-009-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "260",
    "z": "670",
    "volume": "99",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-009-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "335",
    "z": "670",
    "volume": "22",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-010-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "35",
    "z": "670",
    "volume": "11",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-010-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "110",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-010-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "185",
    "z": "670",
    "volume": "3",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-010-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "260",
    "z": "670",
    "volume": "20",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-010-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "335",
    "z": "670",
    "volume": "90",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-011-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "35",
    "z": "670",
    "volume": "100",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-011-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "110",
    "z": "670",
    "volume": "55",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-011-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "185",
    "z": "670",
    "volume": "67",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-011-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "260",
    "z": "670",
    "volume": "82",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-011-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "335",
    "z": "670",
    "volume": "74",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-012-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "35",
    "z": "670",
    "volume": "47",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-012-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "110",
    "z": "670",
    "volume": "58",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-012-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "185",
    "z": "670",
    "volume": "56",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-012-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "260",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-012-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "335",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-013-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "35",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-013-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "110",
    "z": "670",
    "volume": "3",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-013-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "185",
    "z": "670",
    "volume": "20",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-013-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "260",
    "z": "670",
    "volume": "90",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-013-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "335",
    "z": "670",
    "volume": "100",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-014-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "35",
    "z": "670",
    "volume": "55",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-014-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "110",
    "z": "670",
    "volume": "67",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-014-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "185",
    "z": "670",
    "volume": "82",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-014-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "260",
    "z": "670",
    "volume": "74",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-014-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "335",
    "z": "670",
    "volume": "47",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-015-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "35",
    "z": "670",
    "volume": "58",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-015-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "110",
    "z": "670",
    "volume": "56",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-015-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "185",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-015-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "260",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-015-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "335",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-016-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "35",
    "z": "670",
    "volume": "3",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-016-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "110",
    "z": "670",
    "volume": "20",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-016-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "185",
    "z": "670",
    "volume": "90",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-016-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "260",
    "z": "670",
    "volume": "100",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-016-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "335",
    "z": "670",
    "volume": "55",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-017-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "35",
    "z": "670",
    "volume": "67",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-017-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "110",
    "z": "670",
    "volume": "82",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-017-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "185",
    "z": "670",
    "volume": "74",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-017-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "260",
    "z": "670",
    "volume": "47",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-017-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "335",
    "z": "670",
    "volume": "58",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-018-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "35",
    "z": "670",
    "volume": "56",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-018-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "110",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-018-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "185",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-018-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "260",
    "z": "670",
    "volume": "23",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-018-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "335",
    "z": "670",
    "volume": "77",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-019-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "35",
    "z": "670",
    "volume": "88",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-019-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "110",
    "z": "670",
    "volume": "99",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-019-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "185",
    "z": "670",
    "volume": "22",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-019-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "260",
    "z": "670",
    "volume": "11",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-019-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "335",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-020-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "35",
    "z": "670",
    "volume": "3",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-020-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "110",
    "z": "670",
    "volume": "20",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-020-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "185",
    "z": "670",
    "volume": "90",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-020-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "260",
    "z": "670",
    "volume": "100",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-020-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "335",
    "z": "670",
    "volume": "55",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-021-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "35",
    "z": "670",
    "volume": "67",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-021-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "110",
    "z": "670",
    "volume": "82",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-021-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "185",
    "z": "670",
    "volume": "74",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-021-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "260",
    "z": "670",
    "volume": "47",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-021-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "335",
    "z": "670",
    "volume": "58",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-022-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "35",
    "z": "670",
    "volume": "56",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-022-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "110",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-022-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "185",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-022-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "260",
    "z": "670",
    "volume": "63",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-022-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "335",
    "z": "670",
    "volume": "77",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-023-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "35",
    "z": "670",
    "volume": "88",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-023-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "110",
    "z": "670",
    "volume": "99",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-023-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "185",
    "z": "670",
    "volume": "22",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-023-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "260",
    "z": "670",
    "volume": "11",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-023-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "335",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-024-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "35",
    "z": "670",
    "volume": "3",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-024-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "110",
    "z": "670",
    "volume": "20",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-024-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "185",
    "z": "670",
    "volume": "90",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-024-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "260",
    "z": "670",
    "volume": "100",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-024-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "335",
    "z": "670",
    "volume": "55",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-025-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "35",
    "z": "670",
    "volume": "67",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-025-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "110",
    "z": "670",
    "volume": "82",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-025-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "185",
    "z": "670",
    "volume": "74",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-025-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "260",
    "z": "670",
    "volume": "47",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-025-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "335",
    "z": "670",
    "volume": "58",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-026-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "35",
    "z": "670",
    "volume": "56",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-026-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "110",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-026-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "185",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-026-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "260",
    "z": "670",
    "volume": "85",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-026-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "335",
    "z": "670",
    "volume": "77",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-027-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "35",
    "z": "670",
    "volume": "88",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-027-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "110",
    "z": "670",
    "volume": "99",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-027-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "185",
    "z": "670",
    "volume": "22",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-027-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "260",
    "z": "670",
    "volume": "11",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-027-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "335",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-028-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "35",
    "z": "670",
    "volume": "3",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-028-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "110",
    "z": "670",
    "volume": "20",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-028-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "185",
    "z": "670",
    "volume": "90",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-028-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "260",
    "z": "670",
    "volume": "100",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-028-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "335",
    "z": "670",
    "volume": "55",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-029-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "35",
    "z": "670",
    "volume": "67",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-029-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "110",
    "z": "670",
    "volume": "82",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-029-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "185",
    "z": "670",
    "volume": "74",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-029-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "260",
    "z": "670",
    "volume": "47",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-029-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "335",
    "z": "670",
    "volume": "58",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-030-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "35",
    "z": "670",
    "volume": "56",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-030-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "110",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-030-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "185",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-030-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "260",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-030-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "335",
    "z": "670",
    "volume": "3",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-031-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "35",
    "z": "670",
    "volume": "20",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-031-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "110",
    "z": "670",
    "volume": "90",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-031-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "185",
    "z": "670",
    "volume": "100",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-031-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "260",
    "z": "670",
    "volume": "55",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-031-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "335",
    "z": "670",
    "volume": "67",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-032-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "35",
    "z": "670",
    "volume": "82",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-032-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "110",
    "z": "670",
    "volume": "74",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-032-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "185",
    "z": "670",
    "volume": "47",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-032-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "260",
    "z": "670",
    "volume": "58",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-032-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "335",
    "z": "670",
    "volume": "56",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-033-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "35",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-033-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "110",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-033-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "185",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-033-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "260",
    "z": "670",
    "volume": "3",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-033-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "335",
    "z": "670",
    "volume": "20",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-034-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "35",
    "z": "670",
    "volume": "90",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-034-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "110",
    "z": "670",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-034-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "185",
    "z": "670",
    "volume": "55",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-034-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "260",
    "z": "670",
    "volume": "67",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-034-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "335",
    "z": "670",
    "volume": "82",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-035-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "35",
    "z": "670",
    "volume": "74",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-035-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "110",
    "z": "670",
    "volume": "47",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-035-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "185",
    "z": "670",
    "volume": "58",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-035-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "260",
    "z": "670",
    "volume": "56",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-035-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "335",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-036-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "35",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-036-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "110",
    "z": "670",
    "volume": "23",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-036-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "185",
    "z": "670",
    "volume": "77",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-036-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "260",
    "z": "670",
    "volume": "88",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-036-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "335",
    "z": "670",
    "volume": "99",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-037-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "35",
    "z": "670",
    "volume": "22",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-037-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "110",
    "z": "670",
    "volume": "11",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-037-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "185",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-037-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "260",
    "z": "670",
    "volume": "3",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-037-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "335",
    "z": "670",
    "volume": "20",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-038-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "35",
    "z": "670",
    "volume": "90",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-038-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "110",
    "z": "670",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-038-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "185",
    "z": "670",
    "volume": "55",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-038-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "260",
    "z": "670",
    "volume": "67",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-038-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "335",
    "z": "670",
    "volume": "82",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-039-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "35",
    "z": "670",
    "volume": "74",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-039-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "110",
    "z": "670",
    "volume": "47",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-039-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "185",
    "z": "670",
    "volume": "58",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-039-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "260",
    "z": "670",
    "volume": "56",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-039-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "335",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-040-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "35",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-040-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "110",
    "z": "670",
    "volume": "63",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-040-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "185",
    "z": "670",
    "volume": "77",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-040-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "260",
    "z": "670",
    "volume": "88",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-040-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "335",
    "z": "670",
    "volume": "99",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-041-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "35",
    "z": "670",
    "volume": "22",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-041-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "110",
    "z": "670",
    "volume": "11",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-041-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "185",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-041-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "260",
    "z": "670",
    "volume": "3",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-041-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "335",
    "z": "670",
    "volume": "20",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-042-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "35",
    "z": "670",
    "volume": "90",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-042-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "110",
    "z": "670",
    "volume": "100",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-042-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "185",
    "z": "670",
    "volume": "55",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-042-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "260",
    "z": "670",
    "volume": "67",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-042-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "335",
    "z": "670",
    "volume": "82",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-043-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "35",
    "z": "670",
    "volume": "74",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-043-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "110",
    "z": "670",
    "volume": "47",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-043-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "185",
    "z": "670",
    "volume": "58",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-043-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "260",
    "z": "670",
    "volume": "56",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-043-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "335",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-044-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "35",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-044-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "110",
    "z": "670",
    "volume": "85",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-044-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "185",
    "z": "670",
    "volume": "77",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-044-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "260",
    "z": "670",
    "volume": "88",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-044-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "335",
    "z": "670",
    "volume": "99",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-045-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "35",
    "z": "670",
    "volume": "22",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-045-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "110",
    "z": "670",
    "volume": "11",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-045-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "185",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-045-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "260",
    "z": "670",
    "volume": "3",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-045-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "335",
    "z": "670",
    "volume": "20",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-046-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "35",
    "z": "670",
    "volume": "90",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-046-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "110",
    "z": "670",
    "volume": "100",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-046-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "185",
    "z": "670",
    "volume": "55",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-046-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "260",
    "z": "670",
    "volume": "67",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-046-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "335",
    "z": "670",
    "volume": "82",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-047-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "35",
    "z": "670",
    "volume": "74",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-047-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "110",
    "z": "670",
    "volume": "47",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-047-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "185",
    "z": "670",
    "volume": "58",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-047-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "260",
    "z": "670",
    "volume": "56",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-047-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "335",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-048-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "35",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-048-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "110",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-048-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "185",
    "z": "670",
    "volume": "3",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-048-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "260",
    "z": "670",
    "volume": "20",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-048-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "335",
    "z": "670",
    "volume": "90",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-049-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "35",
    "z": "670",
    "volume": "100",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-049-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "110",
    "z": "670",
    "volume": "55",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-049-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "185",
    "z": "670",
    "volume": "67",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-049-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "260",
    "z": "670",
    "volume": "82",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-049-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "335",
    "z": "670",
    "volume": "74",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-050-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "35",
    "z": "670",
    "volume": "47",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-050-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "110",
    "z": "670",
    "volume": "58",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-050-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "185",
    "z": "670",
    "volume": "56",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-050-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "260",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-050-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "335",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-051-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "35",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-051-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "110",
    "z": "670",
    "volume": "3",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-051-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "185",
    "z": "670",
    "volume": "20",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-051-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "260",
    "z": "670",
    "volume": "90",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-051-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "335",
    "z": "670",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-052-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "35",
    "z": "670",
    "volume": "55",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-052-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "110",
    "z": "670",
    "volume": "67",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-052-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "185",
    "z": "670",
    "volume": "82",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-052-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "260",
    "z": "670",
    "volume": "74",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-052-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "335",
    "z": "670",
    "volume": "47",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-053-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "35",
    "z": "670",
    "volume": "58",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-053-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "110",
    "z": "670",
    "volume": "56",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-053-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "185",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-053-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "260",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-053-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "335",
    "z": "670",
    "volume": "23",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-054-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "35",
    "z": "670",
    "volume": "77",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-054-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "110",
    "z": "670",
    "volume": "88",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-054-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "185",
    "z": "670",
    "volume": "99",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-054-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "260",
    "z": "670",
    "volume": "22",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-054-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "335",
    "z": "670",
    "volume": "11",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-055-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "35",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-055-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "110",
    "z": "670",
    "volume": "3",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-055-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "185",
    "z": "670",
    "volume": "20",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-055-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "260",
    "z": "670",
    "volume": "90",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-055-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "335",
    "z": "670",
    "volume": "100",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-056-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "35",
    "z": "670",
    "volume": "55",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-056-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "110",
    "z": "670",
    "volume": "67",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-056-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "185",
    "z": "670",
    "volume": "82",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-056-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "260",
    "z": "670",
    "volume": "74",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-056-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "335",
    "z": "670",
    "volume": "47",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-057-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "35",
    "z": "670",
    "volume": "58",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-057-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "110",
    "z": "670",
    "volume": "56",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-057-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "185",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-057-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "260",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-057-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "335",
    "z": "670",
    "volume": "63",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-058-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "35",
    "z": "670",
    "volume": "77",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-058-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "110",
    "z": "670",
    "volume": "88",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-058-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "185",
    "z": "670",
    "volume": "99",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-058-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "260",
    "z": "670",
    "volume": "22",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-058-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "335",
    "z": "670",
    "volume": "11",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-059-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "35",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-059-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "110",
    "z": "670",
    "volume": "3",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-059-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "185",
    "z": "670",
    "volume": "20",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-059-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "260",
    "z": "670",
    "volume": "90",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-059-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "335",
    "z": "670",
    "volume": "100",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-060-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "35",
    "z": "670",
    "volume": "55",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-060-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "110",
    "z": "670",
    "volume": "67",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-060-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "185",
    "z": "670",
    "volume": "82",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-060-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "260",
    "z": "670",
    "volume": "74",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-060-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "335",
    "z": "670",
    "volume": "47",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-061-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "35",
    "z": "670",
    "volume": "58",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-061-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "110",
    "z": "670",
    "volume": "56",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-061-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "185",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-061-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "260",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-061-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "335",
    "z": "670",
    "volume": "85",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-062-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "35",
    "z": "670",
    "volume": "77",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-062-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "110",
    "z": "670",
    "volume": "88",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-062-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "185",
    "z": "670",
    "volume": "99",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-062-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "260",
    "z": "670",
    "volume": "22",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-062-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "335",
    "z": "670",
    "volume": "11",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-063-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "35",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-063-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "110",
    "z": "670",
    "volume": "3",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-063-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "185",
    "z": "670",
    "volume": "20",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-063-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "260",
    "z": "670",
    "volume": "90",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-063-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "335",
    "z": "670",
    "volume": "100",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-064-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "35",
    "z": "670",
    "volume": "55",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-064-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "110",
    "z": "670",
    "volume": "67",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-064-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "185",
    "z": "670",
    "volume": "82",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-064-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "260",
    "z": "670",
    "volume": "74",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-064-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "335",
    "z": "670",
    "volume": "47",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-065-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "35",
    "z": "670",
    "volume": "58",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-065-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "110",
    "z": "670",
    "volume": "56",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-065-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "185",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-065-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "260",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-065-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "335",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-066-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "35",
    "z": "670",
    "volume": "3",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-066-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "110",
    "z": "670",
    "volume": "20",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-066-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "185",
    "z": "670",
    "volume": "90",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-066-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "260",
    "z": "670",
    "volume": "100",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-066-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "335",
    "z": "670",
    "volume": "55",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-067-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "35",
    "z": "670",
    "volume": "67",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-067-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "110",
    "z": "670",
    "volume": "82",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-067-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "185",
    "z": "670",
    "volume": "74",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-067-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "260",
    "z": "670",
    "volume": "47",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-067-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "335",
    "z": "670",
    "volume": "58",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-068-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "35",
    "z": "670",
    "volume": "56",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-068-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "110",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-068-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "185",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-068-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "260",
    "z": "670",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-068-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "335",
    "z": "670",
    "volume": "3",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-069-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "35",
    "z": "670",
    "volume": "20",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-069-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "110",
    "z": "670",
    "volume": "90",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-069-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "185",
    "z": "670",
    "volume": "100",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-069-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "260",
    "z": "670",
    "volume": "55",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-069-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "335",
    "z": "670",
    "volume": "67",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A04-070-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "35",
    "z": "670",
    "volume": "82",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-070-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "110",
    "z": "670",
    "volume": "74",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-070-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "185",
    "z": "670",
    "volume": "47",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-070-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "260",
    "z": "670",
    "volume": "58",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A04-070-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "335",
    "z": "670",
    "volume": "56",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-001-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "35",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-001-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "110",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-001-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "185",
    "z": "720",
    "volume": "23",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-001-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "260",
    "z": "720",
    "volume": "77",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-001-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "335",
    "z": "720",
    "volume": "88",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-002-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "35",
    "z": "720",
    "volume": "99",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-002-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "110",
    "z": "720",
    "volume": "22",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-002-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "185",
    "z": "720",
    "volume": "11",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-002-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "260",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-002-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "335",
    "z": "720",
    "volume": "3",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-003-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "35",
    "z": "720",
    "volume": "20",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-003-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "110",
    "z": "720",
    "volume": "90",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-003-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "185",
    "z": "720",
    "volume": "100",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-003-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "260",
    "z": "720",
    "volume": "55",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-003-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "335",
    "z": "720",
    "volume": "67",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-004-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "35",
    "z": "720",
    "volume": "82",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-004-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "110",
    "z": "720",
    "volume": "74",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-004-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "185",
    "z": "720",
    "volume": "47",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-004-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "260",
    "z": "720",
    "volume": "58",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-004-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "335",
    "z": "720",
    "volume": "56",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-005-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "35",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-005-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "110",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-005-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "185",
    "z": "720",
    "volume": "63",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-005-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "260",
    "z": "720",
    "volume": "77",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-005-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "335",
    "z": "720",
    "volume": "88",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-006-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "35",
    "z": "720",
    "volume": "99",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-006-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "110",
    "z": "720",
    "volume": "22",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-006-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "185",
    "z": "720",
    "volume": "11",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-006-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "260",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-006-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "335",
    "z": "720",
    "volume": "3",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-007-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "35",
    "z": "720",
    "volume": "20",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-007-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "110",
    "z": "720",
    "volume": "90",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-007-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "185",
    "z": "720",
    "volume": "100",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-007-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "260",
    "z": "720",
    "volume": "55",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-007-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "335",
    "z": "720",
    "volume": "67",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-008-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "35",
    "z": "720",
    "volume": "82",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-008-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "110",
    "z": "720",
    "volume": "74",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-008-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "185",
    "z": "720",
    "volume": "47",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-008-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "260",
    "z": "720",
    "volume": "58",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-008-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "335",
    "z": "720",
    "volume": "56",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-009-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "35",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-009-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "110",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-009-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "185",
    "z": "720",
    "volume": "85",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-009-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "260",
    "z": "720",
    "volume": "77",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-009-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "335",
    "z": "720",
    "volume": "88",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-010-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "35",
    "z": "720",
    "volume": "99",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-010-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "110",
    "z": "720",
    "volume": "22",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-010-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "185",
    "z": "720",
    "volume": "11",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-010-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "260",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-010-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "335",
    "z": "720",
    "volume": "3",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-011-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "35",
    "z": "720",
    "volume": "20",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-011-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "110",
    "z": "720",
    "volume": "90",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-011-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "185",
    "z": "720",
    "volume": "100",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-011-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "260",
    "z": "720",
    "volume": "55",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-011-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "335",
    "z": "720",
    "volume": "67",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-012-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "35",
    "z": "720",
    "volume": "82",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-012-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "110",
    "z": "720",
    "volume": "74",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-012-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "185",
    "z": "720",
    "volume": "47",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-012-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "260",
    "z": "720",
    "volume": "58",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-012-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "335",
    "z": "720",
    "volume": "56",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-013-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "35",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-013-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "110",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-013-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "185",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-013-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "260",
    "z": "720",
    "volume": "3",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-013-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "335",
    "z": "720",
    "volume": "20",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-014-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "35",
    "z": "720",
    "volume": "90",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-014-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "110",
    "z": "720",
    "volume": "100",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-014-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "185",
    "z": "720",
    "volume": "55",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-014-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "260",
    "z": "720",
    "volume": "67",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-014-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "335",
    "z": "720",
    "volume": "82",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-015-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "35",
    "z": "720",
    "volume": "74",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-015-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "110",
    "z": "720",
    "volume": "47",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-015-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "185",
    "z": "720",
    "volume": "58",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-015-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "260",
    "z": "720",
    "volume": "56",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-015-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "335",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-016-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "35",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-016-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "110",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-016-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "185",
    "z": "720",
    "volume": "3",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-016-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "260",
    "z": "720",
    "volume": "20",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-016-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "335",
    "z": "720",
    "volume": "90",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-017-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "35",
    "z": "720",
    "volume": "100",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-017-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "110",
    "z": "720",
    "volume": "55",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-017-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "185",
    "z": "720",
    "volume": "67",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-017-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "260",
    "z": "720",
    "volume": "82",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-017-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "335",
    "z": "720",
    "volume": "74",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-018-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "35",
    "z": "720",
    "volume": "47",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-018-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "110",
    "z": "720",
    "volume": "58",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-018-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "185",
    "z": "720",
    "volume": "56",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-018-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "260",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-018-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "335",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-019-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "35",
    "z": "720",
    "volume": "23",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-019-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "110",
    "z": "720",
    "volume": "77",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-019-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "185",
    "z": "720",
    "volume": "88",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-019-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "260",
    "z": "720",
    "volume": "99",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-019-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "335",
    "z": "720",
    "volume": "22",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-020-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "35",
    "z": "720",
    "volume": "11",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-020-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "110",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-020-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "185",
    "z": "720",
    "volume": "3",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-020-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "260",
    "z": "720",
    "volume": "20",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-020-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "335",
    "z": "720",
    "volume": "90",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-021-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "35",
    "z": "720",
    "volume": "100",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-021-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "110",
    "z": "720",
    "volume": "55",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-021-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "185",
    "z": "720",
    "volume": "67",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-021-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "260",
    "z": "720",
    "volume": "82",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-021-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "335",
    "z": "720",
    "volume": "74",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-022-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "35",
    "z": "720",
    "volume": "47",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-022-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "110",
    "z": "720",
    "volume": "58",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-022-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "185",
    "z": "720",
    "volume": "56",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-022-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "260",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-022-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "335",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-023-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "35",
    "z": "720",
    "volume": "63",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-023-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "110",
    "z": "720",
    "volume": "77",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-023-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "185",
    "z": "720",
    "volume": "88",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-023-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "260",
    "z": "720",
    "volume": "99",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-023-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "335",
    "z": "720",
    "volume": "22",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-024-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "35",
    "z": "720",
    "volume": "11",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-024-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "110",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-024-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "185",
    "z": "720",
    "volume": "3",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-024-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "260",
    "z": "720",
    "volume": "20",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-024-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "335",
    "z": "720",
    "volume": "90",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-025-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "35",
    "z": "720",
    "volume": "100",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-025-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "110",
    "z": "720",
    "volume": "55",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-025-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "185",
    "z": "720",
    "volume": "67",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-025-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "260",
    "z": "720",
    "volume": "82",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-025-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "335",
    "z": "720",
    "volume": "74",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-026-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "35",
    "z": "720",
    "volume": "47",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-026-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "110",
    "z": "720",
    "volume": "58",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-026-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "185",
    "z": "720",
    "volume": "56",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-026-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "260",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-026-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "335",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-027-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "35",
    "z": "720",
    "volume": "85",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-027-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "110",
    "z": "720",
    "volume": "77",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-027-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "185",
    "z": "720",
    "volume": "88",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-027-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "260",
    "z": "720",
    "volume": "99",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-027-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "335",
    "z": "720",
    "volume": "22",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-028-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "35",
    "z": "720",
    "volume": "11",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-028-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "110",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-028-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "185",
    "z": "720",
    "volume": "3",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-028-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "260",
    "z": "720",
    "volume": "20",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-028-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "335",
    "z": "720",
    "volume": "90",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-029-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "35",
    "z": "720",
    "volume": "100",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-029-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "110",
    "z": "720",
    "volume": "55",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-029-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "185",
    "z": "720",
    "volume": "67",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-029-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "260",
    "z": "720",
    "volume": "82",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-029-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "335",
    "z": "720",
    "volume": "74",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-030-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "35",
    "z": "720",
    "volume": "47",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-030-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "110",
    "z": "720",
    "volume": "58",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-030-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "185",
    "z": "720",
    "volume": "56",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-030-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "260",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-030-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "335",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-031-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "35",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-031-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "110",
    "z": "720",
    "volume": "3",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-031-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "185",
    "z": "720",
    "volume": "20",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-031-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "260",
    "z": "720",
    "volume": "90",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-031-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "335",
    "z": "720",
    "volume": "100",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-032-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "35",
    "z": "720",
    "volume": "55",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-032-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "110",
    "z": "720",
    "volume": "67",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-032-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "185",
    "z": "720",
    "volume": "82",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-032-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "260",
    "z": "720",
    "volume": "74",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-032-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "335",
    "z": "720",
    "volume": "47",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-033-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "35",
    "z": "720",
    "volume": "58",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-033-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "110",
    "z": "720",
    "volume": "56",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-033-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "185",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-033-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "260",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-033-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "335",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-034-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "35",
    "z": "720",
    "volume": "3",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-034-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "110",
    "z": "720",
    "volume": "20",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-034-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "185",
    "z": "720",
    "volume": "90",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-034-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "260",
    "z": "720",
    "volume": "100",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-034-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "335",
    "z": "720",
    "volume": "55",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-035-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "35",
    "z": "720",
    "volume": "67",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-035-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "110",
    "z": "720",
    "volume": "82",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-035-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "185",
    "z": "720",
    "volume": "74",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-035-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "260",
    "z": "720",
    "volume": "47",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-035-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "335",
    "z": "720",
    "volume": "58",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-036-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "35",
    "z": "720",
    "volume": "56",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-036-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "110",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-036-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "185",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-036-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "260",
    "z": "720",
    "volume": "23",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-036-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "335",
    "z": "720",
    "volume": "77",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-037-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "35",
    "z": "720",
    "volume": "88",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-037-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "110",
    "z": "720",
    "volume": "99",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-037-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "185",
    "z": "720",
    "volume": "22",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-037-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "260",
    "z": "720",
    "volume": "11",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-037-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "335",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-038-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "35",
    "z": "720",
    "volume": "3",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-038-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "110",
    "z": "720",
    "volume": "20",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-038-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "185",
    "z": "720",
    "volume": "90",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-038-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "260",
    "z": "720",
    "volume": "100",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-038-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "335",
    "z": "720",
    "volume": "55",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-039-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "35",
    "z": "720",
    "volume": "67",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-039-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "110",
    "z": "720",
    "volume": "82",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-039-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "185",
    "z": "720",
    "volume": "74",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-039-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "260",
    "z": "720",
    "volume": "47",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-039-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "335",
    "z": "720",
    "volume": "58",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-040-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "35",
    "z": "720",
    "volume": "56",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-040-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "110",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-040-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "185",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-040-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "260",
    "z": "720",
    "volume": "63",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-040-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "335",
    "z": "720",
    "volume": "77",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-041-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "35",
    "z": "720",
    "volume": "88",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-041-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "110",
    "z": "720",
    "volume": "99",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-041-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "185",
    "z": "720",
    "volume": "22",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-041-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "260",
    "z": "720",
    "volume": "11",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-041-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "335",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-042-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "35",
    "z": "720",
    "volume": "3",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-042-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "110",
    "z": "720",
    "volume": "20",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-042-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "185",
    "z": "720",
    "volume": "90",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-042-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "260",
    "z": "720",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-042-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "335",
    "z": "720",
    "volume": "55",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-043-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "35",
    "z": "720",
    "volume": "67",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-043-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "110",
    "z": "720",
    "volume": "82",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-043-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "185",
    "z": "720",
    "volume": "74",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-043-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "260",
    "z": "720",
    "volume": "47",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-043-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "335",
    "z": "720",
    "volume": "58",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-044-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "35",
    "z": "720",
    "volume": "56",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-044-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "110",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-044-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "185",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-044-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "260",
    "z": "720",
    "volume": "85",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-044-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "335",
    "z": "720",
    "volume": "77",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-045-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "35",
    "z": "720",
    "volume": "88",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-045-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "110",
    "z": "720",
    "volume": "99",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-045-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "185",
    "z": "720",
    "volume": "22",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-045-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "260",
    "z": "720",
    "volume": "11",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-045-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "335",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-046-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "35",
    "z": "720",
    "volume": "3",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-046-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "110",
    "z": "720",
    "volume": "20",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-046-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "185",
    "z": "720",
    "volume": "90",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-046-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "260",
    "z": "720",
    "volume": "100",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-046-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "335",
    "z": "720",
    "volume": "55",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-047-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "35",
    "z": "720",
    "volume": "67",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-047-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "110",
    "z": "720",
    "volume": "82",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-047-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "185",
    "z": "720",
    "volume": "74",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-047-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "260",
    "z": "720",
    "volume": "47",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-047-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "335",
    "z": "720",
    "volume": "58",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-048-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "35",
    "z": "720",
    "volume": "56",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-048-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "110",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-048-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "185",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-048-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "260",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-048-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "335",
    "z": "720",
    "volume": "3",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-049-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "35",
    "z": "720",
    "volume": "20",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-049-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "110",
    "z": "720",
    "volume": "90",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-049-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "185",
    "z": "720",
    "volume": "100",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-049-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "260",
    "z": "720",
    "volume": "55",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-049-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "335",
    "z": "720",
    "volume": "67",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-050-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "35",
    "z": "720",
    "volume": "82",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-050-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "110",
    "z": "720",
    "volume": "74",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-050-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "185",
    "z": "720",
    "volume": "47",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-050-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "260",
    "z": "720",
    "volume": "58",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-050-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "335",
    "z": "720",
    "volume": "56",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-051-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "35",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-051-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "110",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-051-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "185",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-051-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "260",
    "z": "720",
    "volume": "3",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-051-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "335",
    "z": "720",
    "volume": "20",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-052-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "35",
    "z": "720",
    "volume": "90",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-052-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "110",
    "z": "720",
    "volume": "100",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-052-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "185",
    "z": "720",
    "volume": "55",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-052-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "260",
    "z": "720",
    "volume": "67",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-052-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "335",
    "z": "720",
    "volume": "82",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-053-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "35",
    "z": "720",
    "volume": "74",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-053-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "110",
    "z": "720",
    "volume": "47",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-053-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "185",
    "z": "720",
    "volume": "58",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-053-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "260",
    "z": "720",
    "volume": "56",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-053-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "335",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-054-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "35",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-054-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "110",
    "z": "720",
    "volume": "23",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-054-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "185",
    "z": "720",
    "volume": "77",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-054-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "260",
    "z": "720",
    "volume": "88",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-054-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "335",
    "z": "720",
    "volume": "99",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-055-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "35",
    "z": "720",
    "volume": "22",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-055-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "110",
    "z": "720",
    "volume": "11",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-055-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "185",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-055-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "260",
    "z": "720",
    "volume": "3",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-055-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "335",
    "z": "720",
    "volume": "20",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-056-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "35",
    "z": "720",
    "volume": "90",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-056-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "110",
    "z": "720",
    "volume": "100",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-056-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "185",
    "z": "720",
    "volume": "55",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-056-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "260",
    "z": "720",
    "volume": "67",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-056-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "335",
    "z": "720",
    "volume": "82",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-057-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "35",
    "z": "720",
    "volume": "74",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-057-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "110",
    "z": "720",
    "volume": "47",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-057-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "185",
    "z": "720",
    "volume": "58",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-057-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "260",
    "z": "720",
    "volume": "56",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-057-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "335",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-058-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "35",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-058-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "110",
    "z": "720",
    "volume": "63",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-058-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "185",
    "z": "720",
    "volume": "77",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-058-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "260",
    "z": "720",
    "volume": "88",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-058-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "335",
    "z": "720",
    "volume": "99",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-059-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "35",
    "z": "720",
    "volume": "22",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-059-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "110",
    "z": "720",
    "volume": "11",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-059-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "185",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-059-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "260",
    "z": "720",
    "volume": "3",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-059-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "335",
    "z": "720",
    "volume": "20",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-060-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "35",
    "z": "720",
    "volume": "90",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-060-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "110",
    "z": "720",
    "volume": "100",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-060-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "185",
    "z": "720",
    "volume": "55",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-060-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "260",
    "z": "720",
    "volume": "67",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-060-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "335",
    "z": "720",
    "volume": "82",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-061-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "35",
    "z": "720",
    "volume": "74",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-061-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "110",
    "z": "720",
    "volume": "47",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-061-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "185",
    "z": "720",
    "volume": "58",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-061-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "260",
    "z": "720",
    "volume": "56",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-061-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "335",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-062-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "35",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-062-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "110",
    "z": "720",
    "volume": "85",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-062-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "185",
    "z": "720",
    "volume": "77",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-062-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "260",
    "z": "720",
    "volume": "88",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-062-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "335",
    "z": "720",
    "volume": "99",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-063-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "35",
    "z": "720",
    "volume": "22",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-063-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "110",
    "z": "720",
    "volume": "11",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-063-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "185",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-063-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "260",
    "z": "720",
    "volume": "3",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-063-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "335",
    "z": "720",
    "volume": "20",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-064-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "35",
    "z": "720",
    "volume": "90",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-064-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "110",
    "z": "720",
    "volume": "100",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-064-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "185",
    "z": "720",
    "volume": "55",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-064-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "260",
    "z": "720",
    "volume": "67",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-064-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "335",
    "z": "720",
    "volume": "82",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-065-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "35",
    "z": "720",
    "volume": "74",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-065-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "110",
    "z": "720",
    "volume": "47",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-065-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "185",
    "z": "720",
    "volume": "58",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-065-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "260",
    "z": "720",
    "volume": "56",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-065-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "335",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-066-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "35",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-066-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "110",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-066-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "185",
    "z": "720",
    "volume": "3",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-066-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "260",
    "z": "720",
    "volume": "20",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-066-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "335",
    "z": "720",
    "volume": "90",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-067-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "35",
    "z": "720",
    "volume": "100",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-067-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "110",
    "z": "720",
    "volume": "55",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-067-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "185",
    "z": "720",
    "volume": "67",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-067-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "260",
    "z": "720",
    "volume": "82",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-067-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "335",
    "z": "720",
    "volume": "74",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-068-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "35",
    "z": "720",
    "volume": "47",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-068-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "110",
    "z": "720",
    "volume": "58",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-068-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "185",
    "z": "720",
    "volume": "56",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-068-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "260",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-068-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "335",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-069-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "35",
    "z": "720",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-069-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "110",
    "z": "720",
    "volume": "3",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-069-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "185",
    "z": "720",
    "volume": "20",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-069-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "260",
    "z": "720",
    "volume": "90",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-069-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "335",
    "z": "720",
    "volume": "100",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A05-070-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "35",
    "z": "720",
    "volume": "55",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-070-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "110",
    "z": "720",
    "volume": "67",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-070-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "185",
    "z": "720",
    "volume": "82",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-070-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "260",
    "z": "720",
    "volume": "74",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A05-070-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "335",
    "z": "720",
    "volume": "47",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-001-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "35",
    "z": "1020",
    "volume": "58",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-001-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "110",
    "z": "1020",
    "volume": "56",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-001-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "185",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-001-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "260",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-001-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "335",
    "z": "1020",
    "volume": "23",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-002-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "35",
    "z": "1020",
    "volume": "77",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-002-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "110",
    "z": "1020",
    "volume": "88",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-002-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "185",
    "z": "1020",
    "volume": "99",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-002-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "260",
    "z": "1020",
    "volume": "22",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-002-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "335",
    "z": "1020",
    "volume": "11",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-003-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "35",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-003-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "110",
    "z": "1020",
    "volume": "3",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-003-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "185",
    "z": "1020",
    "volume": "20",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-003-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "260",
    "z": "1020",
    "volume": "90",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-003-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "335",
    "z": "1020",
    "volume": "100",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-004-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "35",
    "z": "1020",
    "volume": "55",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-004-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "110",
    "z": "1020",
    "volume": "67",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-004-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "185",
    "z": "1020",
    "volume": "82",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-004-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "260",
    "z": "1020",
    "volume": "74",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-004-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "335",
    "z": "1020",
    "volume": "47",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-005-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "35",
    "z": "1020",
    "volume": "58",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-005-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "110",
    "z": "1020",
    "volume": "56",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-005-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "185",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-005-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "260",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-005-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "335",
    "z": "1020",
    "volume": "63",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-006-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "35",
    "z": "1020",
    "volume": "77",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-006-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "110",
    "z": "1020",
    "volume": "88",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-006-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "185",
    "z": "1020",
    "volume": "99",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-006-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "260",
    "z": "1020",
    "volume": "22",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-006-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "335",
    "z": "1020",
    "volume": "11",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-007-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "35",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-007-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "110",
    "z": "1020",
    "volume": "3",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-007-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "185",
    "z": "1020",
    "volume": "20",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-007-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "260",
    "z": "1020",
    "volume": "90",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-007-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "335",
    "z": "1020",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-008-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "35",
    "z": "1020",
    "volume": "55",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-008-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "110",
    "z": "1020",
    "volume": "67",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-008-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "185",
    "z": "1020",
    "volume": "82",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-008-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "260",
    "z": "1020",
    "volume": "74",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-008-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "335",
    "z": "1020",
    "volume": "47",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-009-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "35",
    "z": "1020",
    "volume": "58",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-009-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "110",
    "z": "1020",
    "volume": "56",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-009-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "185",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-009-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "260",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-009-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "335",
    "z": "1020",
    "volume": "85",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-010-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "35",
    "z": "1020",
    "volume": "77",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-010-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "110",
    "z": "1020",
    "volume": "88",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-010-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "185",
    "z": "1020",
    "volume": "99",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-010-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "260",
    "z": "1020",
    "volume": "22",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-010-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "335",
    "z": "1020",
    "volume": "11",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-011-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "35",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-011-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "110",
    "z": "1020",
    "volume": "3",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-011-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "185",
    "z": "1020",
    "volume": "20",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-011-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "260",
    "z": "1020",
    "volume": "90",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-011-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "335",
    "z": "1020",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-012-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "35",
    "z": "1020",
    "volume": "55",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-012-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "110",
    "z": "1020",
    "volume": "67",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-012-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "185",
    "z": "1020",
    "volume": "82",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-012-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "260",
    "z": "1020",
    "volume": "74",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-012-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "335",
    "z": "1020",
    "volume": "47",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-013-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "35",
    "z": "1020",
    "volume": "58",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-013-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "110",
    "z": "1020",
    "volume": "56",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-013-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "185",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-013-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "260",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-013-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "335",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-014-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "35",
    "z": "1020",
    "volume": "3",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-014-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "110",
    "z": "1020",
    "volume": "20",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-014-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "185",
    "z": "1020",
    "volume": "90",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-014-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "260",
    "z": "1020",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-014-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "335",
    "z": "1020",
    "volume": "55",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-015-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "35",
    "z": "1020",
    "volume": "67",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-015-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "110",
    "z": "1020",
    "volume": "82",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-015-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "185",
    "z": "1020",
    "volume": "74",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-015-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "260",
    "z": "1020",
    "volume": "47",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-015-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "335",
    "z": "1020",
    "volume": "58",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-016-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "35",
    "z": "1020",
    "volume": "56",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-016-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "110",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-016-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "185",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-016-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "260",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-016-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "335",
    "z": "1020",
    "volume": "3",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-017-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "35",
    "z": "1020",
    "volume": "20",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-017-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "110",
    "z": "1020",
    "volume": "90",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-017-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "185",
    "z": "1020",
    "volume": "100",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-017-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "260",
    "z": "1020",
    "volume": "55",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-017-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "335",
    "z": "1020",
    "volume": "67",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-018-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "35",
    "z": "1020",
    "volume": "82",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-018-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "110",
    "z": "1020",
    "volume": "74",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-018-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "185",
    "z": "1020",
    "volume": "47",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-018-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "260",
    "z": "1020",
    "volume": "58",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-018-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "335",
    "z": "1020",
    "volume": "56",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-019-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "35",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-019-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "110",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-019-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "185",
    "z": "1020",
    "volume": "23",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-019-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "260",
    "z": "1020",
    "volume": "77",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-019-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "335",
    "z": "1020",
    "volume": "88",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-020-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "35",
    "z": "1020",
    "volume": "99",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-020-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "110",
    "z": "1020",
    "volume": "22",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-020-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "185",
    "z": "1020",
    "volume": "11",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-020-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "260",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-020-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "335",
    "z": "1020",
    "volume": "3",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-021-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "35",
    "z": "1020",
    "volume": "20",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-021-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "110",
    "z": "1020",
    "volume": "90",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-021-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "185",
    "z": "1020",
    "volume": "100",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-021-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "260",
    "z": "1020",
    "volume": "55",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-021-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "335",
    "z": "1020",
    "volume": "67",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-022-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "35",
    "z": "1020",
    "volume": "82",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-022-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "110",
    "z": "1020",
    "volume": "74",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-022-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "185",
    "z": "1020",
    "volume": "47",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-022-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "260",
    "z": "1020",
    "volume": "58",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-022-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "335",
    "z": "1020",
    "volume": "56",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-023-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "35",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-023-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "110",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-023-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "185",
    "z": "1020",
    "volume": "63",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-023-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "260",
    "z": "1020",
    "volume": "77",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-023-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "335",
    "z": "1020",
    "volume": "88",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-024-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "35",
    "z": "1020",
    "volume": "99",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-024-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "110",
    "z": "1020",
    "volume": "22",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-024-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "185",
    "z": "1020",
    "volume": "11",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-024-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "260",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-024-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "335",
    "z": "1020",
    "volume": "3",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-025-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "35",
    "z": "1020",
    "volume": "20",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-025-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "110",
    "z": "1020",
    "volume": "90",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-025-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "185",
    "z": "1020",
    "volume": "100",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-025-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "260",
    "z": "1020",
    "volume": "55",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-025-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "335",
    "z": "1020",
    "volume": "67",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-026-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "35",
    "z": "1020",
    "volume": "82",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-026-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "110",
    "z": "1020",
    "volume": "74",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-026-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "185",
    "z": "1020",
    "volume": "47",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-026-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "260",
    "z": "1020",
    "volume": "58",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-026-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "335",
    "z": "1020",
    "volume": "56",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-027-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "35",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-027-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "110",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-027-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "185",
    "z": "1020",
    "volume": "85",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-027-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "260",
    "z": "1020",
    "volume": "77",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-027-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "335",
    "z": "1020",
    "volume": "88",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-028-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "35",
    "z": "1020",
    "volume": "99",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-028-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "110",
    "z": "1020",
    "volume": "22",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-028-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "185",
    "z": "1020",
    "volume": "11",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-028-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "260",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-028-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "335",
    "z": "1020",
    "volume": "3",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-029-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "35",
    "z": "1020",
    "volume": "20",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-029-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "110",
    "z": "1020",
    "volume": "90",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-029-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "185",
    "z": "1020",
    "volume": "100",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-029-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "260",
    "z": "1020",
    "volume": "55",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-029-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "335",
    "z": "1020",
    "volume": "67",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-030-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "35",
    "z": "1020",
    "volume": "82",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-030-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "110",
    "z": "1020",
    "volume": "74",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-030-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "185",
    "z": "1020",
    "volume": "47",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-030-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "260",
    "z": "1020",
    "volume": "58",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-030-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "335",
    "z": "1020",
    "volume": "56",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-031-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "35",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-031-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "110",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-031-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "185",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-031-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "260",
    "z": "1020",
    "volume": "3",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-031-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "335",
    "z": "1020",
    "volume": "20",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-032-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "35",
    "z": "1020",
    "volume": "90",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-032-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "110",
    "z": "1020",
    "volume": "100",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-032-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "185",
    "z": "1020",
    "volume": "55",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-032-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "260",
    "z": "1020",
    "volume": "67",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-032-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "335",
    "z": "1020",
    "volume": "82",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-033-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "35",
    "z": "1020",
    "volume": "74",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-033-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "110",
    "z": "1020",
    "volume": "47",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-033-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "185",
    "z": "1020",
    "volume": "58",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-033-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "260",
    "z": "1020",
    "volume": "56",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-033-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "335",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-034-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "35",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-034-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "110",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-034-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "185",
    "z": "1020",
    "volume": "3",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-034-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "260",
    "z": "1020",
    "volume": "20",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-034-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "335",
    "z": "1020",
    "volume": "90",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-035-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "35",
    "z": "1020",
    "volume": "100",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-035-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "110",
    "z": "1020",
    "volume": "55",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-035-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "185",
    "z": "1020",
    "volume": "67",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-035-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "260",
    "z": "1020",
    "volume": "82",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-035-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "335",
    "z": "1020",
    "volume": "74",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-036-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "35",
    "z": "1020",
    "volume": "47",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-036-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "110",
    "z": "1020",
    "volume": "58",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-036-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "185",
    "z": "1020",
    "volume": "56",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-036-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "260",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-036-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "335",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-037-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "35",
    "z": "1020",
    "volume": "23",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-037-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "110",
    "z": "1020",
    "volume": "77",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-037-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "185",
    "z": "1020",
    "volume": "88",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-037-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "260",
    "z": "1020",
    "volume": "99",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-037-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "335",
    "z": "1020",
    "volume": "22",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-038-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "35",
    "z": "1020",
    "volume": "11",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-038-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "110",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-038-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "185",
    "z": "1020",
    "volume": "3",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-038-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "260",
    "z": "1020",
    "volume": "20",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-038-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "335",
    "z": "1020",
    "volume": "90",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-039-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "35",
    "z": "1020",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-039-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "110",
    "z": "1020",
    "volume": "55",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-039-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "185",
    "z": "1020",
    "volume": "67",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-039-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "260",
    "z": "1020",
    "volume": "82",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-039-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "335",
    "z": "1020",
    "volume": "74",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-040-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "35",
    "z": "1020",
    "volume": "47",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-040-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "110",
    "z": "1020",
    "volume": "58",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-040-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "185",
    "z": "1020",
    "volume": "56",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-040-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "260",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-040-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "335",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-041-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "35",
    "z": "1020",
    "volume": "63",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-041-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "110",
    "z": "1020",
    "volume": "77",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-041-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "185",
    "z": "1020",
    "volume": "88",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-041-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "260",
    "z": "1020",
    "volume": "99",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-041-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "335",
    "z": "1020",
    "volume": "22",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-042-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "35",
    "z": "1020",
    "volume": "11",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-042-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "110",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-042-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "185",
    "z": "1020",
    "volume": "3",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-042-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "260",
    "z": "1020",
    "volume": "20",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-042-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "335",
    "z": "1020",
    "volume": "90",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-043-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "35",
    "z": "1020",
    "volume": "100",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-043-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "110",
    "z": "1020",
    "volume": "55",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-043-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "185",
    "z": "1020",
    "volume": "67",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-043-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "260",
    "z": "1020",
    "volume": "82",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-043-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "335",
    "z": "1020",
    "volume": "74",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-044-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "35",
    "z": "1020",
    "volume": "47",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-044-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "110",
    "z": "1020",
    "volume": "58",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-044-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "185",
    "z": "1020",
    "volume": "56",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-044-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "260",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-044-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "335",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-045-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "35",
    "z": "1020",
    "volume": "85",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-045-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "110",
    "z": "1020",
    "volume": "77",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-045-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "185",
    "z": "1020",
    "volume": "88",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-045-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "260",
    "z": "1020",
    "volume": "99",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-045-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "335",
    "z": "1020",
    "volume": "22",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-046-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "35",
    "z": "1020",
    "volume": "11",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-046-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "110",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-046-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "185",
    "z": "1020",
    "volume": "3",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-046-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "260",
    "z": "1020",
    "volume": "20",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-046-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "335",
    "z": "1020",
    "volume": "90",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-047-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "35",
    "z": "1020",
    "volume": "100",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-047-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "110",
    "z": "1020",
    "volume": "55",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-047-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "185",
    "z": "1020",
    "volume": "67",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-047-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "260",
    "z": "1020",
    "volume": "82",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-047-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "335",
    "z": "1020",
    "volume": "74",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-048-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "35",
    "z": "1020",
    "volume": "47",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-048-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "110",
    "z": "1020",
    "volume": "58",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-048-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "185",
    "z": "1020",
    "volume": "56",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-048-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "260",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-048-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "335",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-049-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "35",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-049-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "110",
    "z": "1020",
    "volume": "3",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-049-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "185",
    "z": "1020",
    "volume": "20",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-049-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "260",
    "z": "1020",
    "volume": "90",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-049-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "335",
    "z": "1020",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-050-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "35",
    "z": "1020",
    "volume": "55",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-050-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "110",
    "z": "1020",
    "volume": "67",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-050-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "185",
    "z": "1020",
    "volume": "82",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-050-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "260",
    "z": "1020",
    "volume": "74",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-050-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "335",
    "z": "1020",
    "volume": "47",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-051-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "35",
    "z": "1020",
    "volume": "58",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-051-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "110",
    "z": "1020",
    "volume": "56",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-051-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "185",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-051-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "260",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-051-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "335",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-052-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "35",
    "z": "1020",
    "volume": "3",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-052-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "110",
    "z": "1020",
    "volume": "20",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-052-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "185",
    "z": "1020",
    "volume": "90",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-052-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "260",
    "z": "1020",
    "volume": "100",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-052-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "335",
    "z": "1020",
    "volume": "55",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-053-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "35",
    "z": "1020",
    "volume": "67",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-053-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "110",
    "z": "1020",
    "volume": "82",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-053-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "185",
    "z": "1020",
    "volume": "74",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-053-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "260",
    "z": "1020",
    "volume": "47",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-053-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "335",
    "z": "1020",
    "volume": "58",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-054-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "35",
    "z": "1020",
    "volume": "56",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-054-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "110",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-054-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "185",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-054-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "260",
    "z": "1020",
    "volume": "23",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-054-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "335",
    "z": "1020",
    "volume": "77",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-055-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "35",
    "z": "1020",
    "volume": "88",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-055-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "110",
    "z": "1020",
    "volume": "99",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-055-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "185",
    "z": "1020",
    "volume": "22",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-055-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "260",
    "z": "1020",
    "volume": "11",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-055-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "335",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-056-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "35",
    "z": "1020",
    "volume": "3",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-056-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "110",
    "z": "1020",
    "volume": "20",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-056-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "185",
    "z": "1020",
    "volume": "90",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-056-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "260",
    "z": "1020",
    "volume": "100",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-056-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "335",
    "z": "1020",
    "volume": "55",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-057-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "35",
    "z": "1020",
    "volume": "67",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-057-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "110",
    "z": "1020",
    "volume": "82",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-057-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "185",
    "z": "1020",
    "volume": "74",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-057-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "260",
    "z": "1020",
    "volume": "47",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-057-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "335",
    "z": "1020",
    "volume": "58",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-058-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "35",
    "z": "1020",
    "volume": "56",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-058-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "110",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-058-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "185",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-058-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "260",
    "z": "1020",
    "volume": "63",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-058-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "335",
    "z": "1020",
    "volume": "77",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-059-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "35",
    "z": "1020",
    "volume": "88",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-059-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "110",
    "z": "1020",
    "volume": "99",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-059-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "185",
    "z": "1020",
    "volume": "22",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-059-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "260",
    "z": "1020",
    "volume": "11",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-059-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "335",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-060-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "35",
    "z": "1020",
    "volume": "3",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-060-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "110",
    "z": "1020",
    "volume": "20",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-060-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "185",
    "z": "1020",
    "volume": "90",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-060-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "260",
    "z": "1020",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-060-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "335",
    "z": "1020",
    "volume": "55",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-061-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "35",
    "z": "1020",
    "volume": "67",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-061-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "110",
    "z": "1020",
    "volume": "82",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-061-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "185",
    "z": "1020",
    "volume": "74",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-061-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "260",
    "z": "1020",
    "volume": "47",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-061-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "335",
    "z": "1020",
    "volume": "58",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-062-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "35",
    "z": "1020",
    "volume": "56",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-062-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "110",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-062-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "185",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-062-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "260",
    "z": "1020",
    "volume": "85",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-062-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "335",
    "z": "1020",
    "volume": "77",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-063-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "35",
    "z": "1020",
    "volume": "88",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-063-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "110",
    "z": "1020",
    "volume": "99",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-063-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "185",
    "z": "1020",
    "volume": "22",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-063-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "260",
    "z": "1020",
    "volume": "11",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-063-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "335",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-064-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "35",
    "z": "1020",
    "volume": "3",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-064-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "110",
    "z": "1020",
    "volume": "20",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-064-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "185",
    "z": "1020",
    "volume": "90",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-064-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "260",
    "z": "1020",
    "volume": "100",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-064-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "335",
    "z": "1020",
    "volume": "55",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-065-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "35",
    "z": "1020",
    "volume": "67",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-065-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "110",
    "z": "1020",
    "volume": "82",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-065-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "185",
    "z": "1020",
    "volume": "74",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-065-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "260",
    "z": "1020",
    "volume": "47",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-065-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "335",
    "z": "1020",
    "volume": "58",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-066-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "35",
    "z": "1020",
    "volume": "56",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-066-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "110",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-066-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "185",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-066-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "260",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-066-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "335",
    "z": "1020",
    "volume": "3",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-067-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "35",
    "z": "1020",
    "volume": "20",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-067-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "110",
    "z": "1020",
    "volume": "90",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-067-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "185",
    "z": "1020",
    "volume": "100",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-067-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "260",
    "z": "1020",
    "volume": "55",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-067-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "335",
    "z": "1020",
    "volume": "67",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-068-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "35",
    "z": "1020",
    "volume": "82",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-068-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "110",
    "z": "1020",
    "volume": "74",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-068-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "185",
    "z": "1020",
    "volume": "47",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-068-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "260",
    "z": "1020",
    "volume": "58",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-068-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "335",
    "z": "1020",
    "volume": "56",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-069-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "35",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-069-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "110",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-069-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "185",
    "z": "1020",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-069-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "260",
    "z": "1020",
    "volume": "3",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-069-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "335",
    "z": "1020",
    "volume": "20",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A06-070-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "35",
    "z": "1020",
    "volume": "90",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-070-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "110",
    "z": "1020",
    "volume": "100",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-070-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "185",
    "z": "1020",
    "volume": "55",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-070-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "260",
    "z": "1020",
    "volume": "67",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A06-070-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "335",
    "z": "1020",
    "volume": "82",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-001-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "35",
    "z": "1070",
    "volume": "74",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-001-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "110",
    "z": "1070",
    "volume": "47",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-001-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "185",
    "z": "1070",
    "volume": "58",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-001-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "260",
    "z": "1070",
    "volume": "56",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-001-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "335",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-002-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "35",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-002-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "110",
    "z": "1070",
    "volume": "23",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-002-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "185",
    "z": "1070",
    "volume": "77",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-002-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "260",
    "z": "1070",
    "volume": "88",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-002-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "335",
    "z": "1070",
    "volume": "99",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-003-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "35",
    "z": "1070",
    "volume": "22",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-003-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "110",
    "z": "1070",
    "volume": "11",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-003-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "185",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-003-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "260",
    "z": "1070",
    "volume": "3",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-003-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "335",
    "z": "1070",
    "volume": "20",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-004-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "35",
    "z": "1070",
    "volume": "90",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-004-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "110",
    "z": "1070",
    "volume": "100",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-004-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "185",
    "z": "1070",
    "volume": "55",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-004-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "260",
    "z": "1070",
    "volume": "67",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-004-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "335",
    "z": "1070",
    "volume": "82",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-005-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "35",
    "z": "1070",
    "volume": "74",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-005-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "110",
    "z": "1070",
    "volume": "47",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-005-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "185",
    "z": "1070",
    "volume": "58",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-005-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "260",
    "z": "1070",
    "volume": "56",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-005-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "335",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-006-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "35",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-006-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "110",
    "z": "1070",
    "volume": "63",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-006-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "185",
    "z": "1070",
    "volume": "77",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-006-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "260",
    "z": "1070",
    "volume": "88",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-006-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "335",
    "z": "1070",
    "volume": "99",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-007-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "35",
    "z": "1070",
    "volume": "22",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-007-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "110",
    "z": "1070",
    "volume": "11",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-007-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "185",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-007-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "260",
    "z": "1070",
    "volume": "3",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-007-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "335",
    "z": "1070",
    "volume": "20",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-008-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "35",
    "z": "1070",
    "volume": "90",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-008-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "110",
    "z": "1070",
    "volume": "100",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-008-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "185",
    "z": "1070",
    "volume": "55",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-008-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "260",
    "z": "1070",
    "volume": "67",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-008-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "335",
    "z": "1070",
    "volume": "82",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-009-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "35",
    "z": "1070",
    "volume": "74",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-009-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "110",
    "z": "1070",
    "volume": "47",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-009-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "185",
    "z": "1070",
    "volume": "58",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-009-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "260",
    "z": "1070",
    "volume": "56",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-009-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "335",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-010-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "35",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-010-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "110",
    "z": "1070",
    "volume": "85",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-010-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "185",
    "z": "1070",
    "volume": "77",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-010-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "260",
    "z": "1070",
    "volume": "88",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-010-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "335",
    "z": "1070",
    "volume": "99",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-011-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "35",
    "z": "1070",
    "volume": "22",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-011-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "110",
    "z": "1070",
    "volume": "11",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-011-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "185",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-011-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "260",
    "z": "1070",
    "volume": "3",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-011-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "335",
    "z": "1070",
    "volume": "20",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-012-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "35",
    "z": "1070",
    "volume": "90",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-012-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "110",
    "z": "1070",
    "volume": "100",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-012-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "185",
    "z": "1070",
    "volume": "55",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-012-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "260",
    "z": "1070",
    "volume": "67",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-012-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "335",
    "z": "1070",
    "volume": "82",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-013-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "35",
    "z": "1070",
    "volume": "74",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-013-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "110",
    "z": "1070",
    "volume": "47",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-013-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "185",
    "z": "1070",
    "volume": "58",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-013-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "260",
    "z": "1070",
    "volume": "56",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-013-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "335",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-014-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "35",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-014-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "110",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-014-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "185",
    "z": "1070",
    "volume": "3",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-014-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "260",
    "z": "1070",
    "volume": "20",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-014-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "335",
    "z": "1070",
    "volume": "90",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-015-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "35",
    "z": "1070",
    "volume": "100",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-015-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "110",
    "z": "1070",
    "volume": "55",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-015-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "185",
    "z": "1070",
    "volume": "67",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-015-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "260",
    "z": "1070",
    "volume": "82",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-015-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "335",
    "z": "1070",
    "volume": "74",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-016-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "35",
    "z": "1070",
    "volume": "47",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-016-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "110",
    "z": "1070",
    "volume": "58",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-016-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "185",
    "z": "1070",
    "volume": "56",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-016-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "260",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-016-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "335",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-017-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "35",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-017-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "110",
    "z": "1070",
    "volume": "3",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-017-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "185",
    "z": "1070",
    "volume": "20",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-017-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "260",
    "z": "1070",
    "volume": "90",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-017-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "335",
    "z": "1070",
    "volume": "100",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-018-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "35",
    "z": "1070",
    "volume": "55",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-018-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "110",
    "z": "1070",
    "volume": "67",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-018-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "185",
    "z": "1070",
    "volume": "82",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-018-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "260",
    "z": "1070",
    "volume": "74",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-018-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "335",
    "z": "1070",
    "volume": "47",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-019-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "35",
    "z": "1070",
    "volume": "58",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-019-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "110",
    "z": "1070",
    "volume": "56",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-019-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "185",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-019-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "260",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-019-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "335",
    "z": "1070",
    "volume": "23",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-020-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "35",
    "z": "1070",
    "volume": "77",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-020-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "110",
    "z": "1070",
    "volume": "88",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-020-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "185",
    "z": "1070",
    "volume": "99",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-020-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "260",
    "z": "1070",
    "volume": "22",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-020-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "335",
    "z": "1070",
    "volume": "11",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-021-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "35",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-021-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "110",
    "z": "1070",
    "volume": "3",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-021-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "185",
    "z": "1070",
    "volume": "20",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-021-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "260",
    "z": "1070",
    "volume": "90",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-021-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "335",
    "z": "1070",
    "volume": "100",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-022-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "35",
    "z": "1070",
    "volume": "55",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-022-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "110",
    "z": "1070",
    "volume": "67",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-022-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "185",
    "z": "1070",
    "volume": "82",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-022-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "260",
    "z": "1070",
    "volume": "74",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-022-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "335",
    "z": "1070",
    "volume": "47",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-023-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "35",
    "z": "1070",
    "volume": "58",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-023-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "110",
    "z": "1070",
    "volume": "56",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-023-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "185",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-023-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "260",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-023-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "335",
    "z": "1070",
    "volume": "63",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-024-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "35",
    "z": "1070",
    "volume": "77",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-024-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "110",
    "z": "1070",
    "volume": "88",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-024-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "185",
    "z": "1070",
    "volume": "99",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-024-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "260",
    "z": "1070",
    "volume": "22",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-024-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "335",
    "z": "1070",
    "volume": "11",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-025-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "35",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-025-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "110",
    "z": "1070",
    "volume": "3",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-025-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "185",
    "z": "1070",
    "volume": "20",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-025-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "260",
    "z": "1070",
    "volume": "90",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-025-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "335",
    "z": "1070",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-026-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "35",
    "z": "1070",
    "volume": "55",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-026-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "110",
    "z": "1070",
    "volume": "67",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-026-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "185",
    "z": "1070",
    "volume": "82",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-026-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "260",
    "z": "1070",
    "volume": "74",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-026-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "335",
    "z": "1070",
    "volume": "47",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-027-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "35",
    "z": "1070",
    "volume": "58",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-027-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "110",
    "z": "1070",
    "volume": "56",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-027-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "185",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-027-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "260",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-027-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "335",
    "z": "1070",
    "volume": "85",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-028-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "35",
    "z": "1070",
    "volume": "77",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-028-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "110",
    "z": "1070",
    "volume": "88",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-028-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "185",
    "z": "1070",
    "volume": "99",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-028-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "260",
    "z": "1070",
    "volume": "22",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-028-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "335",
    "z": "1070",
    "volume": "11",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-029-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "35",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-029-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "110",
    "z": "1070",
    "volume": "3",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-029-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "185",
    "z": "1070",
    "volume": "20",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-029-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "260",
    "z": "1070",
    "volume": "90",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-029-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "335",
    "z": "1070",
    "volume": "100",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-030-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "35",
    "z": "1070",
    "volume": "55",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-030-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "110",
    "z": "1070",
    "volume": "67",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-030-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "185",
    "z": "1070",
    "volume": "82",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-030-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "260",
    "z": "1070",
    "volume": "74",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-030-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "335",
    "z": "1070",
    "volume": "47",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-031-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "35",
    "z": "1070",
    "volume": "58",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-031-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "110",
    "z": "1070",
    "volume": "56",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-031-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "185",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-031-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "260",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-031-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "335",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-032-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "35",
    "z": "1070",
    "volume": "3",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-032-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "110",
    "z": "1070",
    "volume": "20",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-032-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "185",
    "z": "1070",
    "volume": "90",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-032-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "260",
    "z": "1070",
    "volume": "100",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-032-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "335",
    "z": "1070",
    "volume": "55",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-033-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "35",
    "z": "1070",
    "volume": "67",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-033-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "110",
    "z": "1070",
    "volume": "82",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-033-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "185",
    "z": "1070",
    "volume": "74",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-033-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "260",
    "z": "1070",
    "volume": "47",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-033-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "335",
    "z": "1070",
    "volume": "58",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-034-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "35",
    "z": "1070",
    "volume": "56",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-034-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "110",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-034-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "185",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-034-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "260",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-034-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "335",
    "z": "1070",
    "volume": "3",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-035-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "35",
    "z": "1070",
    "volume": "20",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-035-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "110",
    "z": "1070",
    "volume": "90",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-035-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "185",
    "z": "1070",
    "volume": "100",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-035-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "260",
    "z": "1070",
    "volume": "55",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-035-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "335",
    "z": "1070",
    "volume": "67",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-036-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "35",
    "z": "1070",
    "volume": "82",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-036-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "110",
    "z": "1070",
    "volume": "74",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-036-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "185",
    "z": "1070",
    "volume": "47",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-036-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "260",
    "z": "1070",
    "volume": "58",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-036-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "335",
    "z": "1070",
    "volume": "56",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-037-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "35",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-037-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "110",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-037-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "185",
    "z": "1070",
    "volume": "23",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-037-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "260",
    "z": "1070",
    "volume": "77",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-037-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "335",
    "z": "1070",
    "volume": "88",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-038-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "35",
    "z": "1070",
    "volume": "99",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-038-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "110",
    "z": "1070",
    "volume": "22",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-038-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "185",
    "z": "1070",
    "volume": "11",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-038-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "260",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-038-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "335",
    "z": "1070",
    "volume": "3",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-039-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "35",
    "z": "1070",
    "volume": "20",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-039-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "110",
    "z": "1070",
    "volume": "90",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-039-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "185",
    "z": "1070",
    "volume": "100",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-039-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "260",
    "z": "1070",
    "volume": "55",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-039-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "335",
    "z": "1070",
    "volume": "67",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-040-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "35",
    "z": "1070",
    "volume": "82",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-040-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "110",
    "z": "1070",
    "volume": "74",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-040-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "185",
    "z": "1070",
    "volume": "47",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-040-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "260",
    "z": "1070",
    "volume": "58",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-040-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "335",
    "z": "1070",
    "volume": "56",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-041-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "35",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-041-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "110",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-041-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "185",
    "z": "1070",
    "volume": "63",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-041-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "260",
    "z": "1070",
    "volume": "77",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-041-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "335",
    "z": "1070",
    "volume": "88",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-042-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "35",
    "z": "1070",
    "volume": "99",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-042-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "110",
    "z": "1070",
    "volume": "22",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-042-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "185",
    "z": "1070",
    "volume": "11",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-042-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "260",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-042-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "335",
    "z": "1070",
    "volume": "3",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-043-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "35",
    "z": "1070",
    "volume": "20",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-043-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "110",
    "z": "1070",
    "volume": "90",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-043-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "185",
    "z": "1070",
    "volume": "100",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-043-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "260",
    "z": "1070",
    "volume": "55",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-043-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "335",
    "z": "1070",
    "volume": "67",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-044-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "35",
    "z": "1070",
    "volume": "82",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-044-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "110",
    "z": "1070",
    "volume": "74",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-044-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "185",
    "z": "1070",
    "volume": "47",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-044-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "260",
    "z": "1070",
    "volume": "58",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-044-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "335",
    "z": "1070",
    "volume": "56",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-045-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "35",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-045-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "110",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-045-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "185",
    "z": "1070",
    "volume": "85",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-045-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "260",
    "z": "1070",
    "volume": "77",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-045-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "335",
    "z": "1070",
    "volume": "88",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-046-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "35",
    "z": "1070",
    "volume": "99",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-046-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "110",
    "z": "1070",
    "volume": "22",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-046-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "185",
    "z": "1070",
    "volume": "11",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-046-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "260",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-046-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "335",
    "z": "1070",
    "volume": "3",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-047-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "35",
    "z": "1070",
    "volume": "20",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-047-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "110",
    "z": "1070",
    "volume": "90",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-047-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "185",
    "z": "1070",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-047-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "260",
    "z": "1070",
    "volume": "55",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-047-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "335",
    "z": "1070",
    "volume": "67",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-048-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "35",
    "z": "1070",
    "volume": "82",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-048-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "110",
    "z": "1070",
    "volume": "74",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-048-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "185",
    "z": "1070",
    "volume": "47",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-048-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "260",
    "z": "1070",
    "volume": "58",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-048-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "335",
    "z": "1070",
    "volume": "56",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-049-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "35",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-049-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "110",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-049-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "185",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-049-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "260",
    "z": "1070",
    "volume": "3",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-049-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "335",
    "z": "1070",
    "volume": "20",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-050-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "35",
    "z": "1070",
    "volume": "90",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-050-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "110",
    "z": "1070",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-050-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "185",
    "z": "1070",
    "volume": "55",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-050-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "260",
    "z": "1070",
    "volume": "67",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-050-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "335",
    "z": "1070",
    "volume": "82",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-051-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "35",
    "z": "1070",
    "volume": "74",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-051-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "110",
    "z": "1070",
    "volume": "47",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-051-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "185",
    "z": "1070",
    "volume": "58",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-051-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "260",
    "z": "1070",
    "volume": "56",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-051-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "335",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-052-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "35",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-052-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "110",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-052-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "185",
    "z": "1070",
    "volume": "3",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-052-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "260",
    "z": "1070",
    "volume": "20",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-052-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "335",
    "z": "1070",
    "volume": "90",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-053-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "35",
    "z": "1070",
    "volume": "100",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-053-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "110",
    "z": "1070",
    "volume": "55",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-053-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "185",
    "z": "1070",
    "volume": "67",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-053-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "260",
    "z": "1070",
    "volume": "82",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-053-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "335",
    "z": "1070",
    "volume": "74",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-054-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "35",
    "z": "1070",
    "volume": "47",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-054-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "110",
    "z": "1070",
    "volume": "58",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-054-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "185",
    "z": "1070",
    "volume": "56",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-054-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "260",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-054-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "335",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-055-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "35",
    "z": "1070",
    "volume": "23",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-055-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "110",
    "z": "1070",
    "volume": "77",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-055-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "185",
    "z": "1070",
    "volume": "88",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-055-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "260",
    "z": "1070",
    "volume": "99",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-055-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "335",
    "z": "1070",
    "volume": "22",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-056-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "35",
    "z": "1070",
    "volume": "11",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-056-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "110",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-056-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "185",
    "z": "1070",
    "volume": "3",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-056-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "260",
    "z": "1070",
    "volume": "20",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-056-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "335",
    "z": "1070",
    "volume": "90",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-057-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "35",
    "z": "1070",
    "volume": "100",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-057-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "110",
    "z": "1070",
    "volume": "55",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-057-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "185",
    "z": "1070",
    "volume": "67",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-057-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "260",
    "z": "1070",
    "volume": "82",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-057-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "335",
    "z": "1070",
    "volume": "74",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-058-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "35",
    "z": "1070",
    "volume": "47",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-058-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "110",
    "z": "1070",
    "volume": "58",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-058-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "185",
    "z": "1070",
    "volume": "56",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-058-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "260",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-058-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "335",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-059-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "35",
    "z": "1070",
    "volume": "63",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-059-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "110",
    "z": "1070",
    "volume": "77",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-059-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "185",
    "z": "1070",
    "volume": "88",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-059-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "260",
    "z": "1070",
    "volume": "99",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-059-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "335",
    "z": "1070",
    "volume": "22",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-060-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "35",
    "z": "1070",
    "volume": "11",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-060-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "110",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-060-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "185",
    "z": "1070",
    "volume": "3",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-060-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "260",
    "z": "1070",
    "volume": "20",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-060-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "335",
    "z": "1070",
    "volume": "90",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-061-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "35",
    "z": "1070",
    "volume": "100",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-061-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "110",
    "z": "1070",
    "volume": "55",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-061-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "185",
    "z": "1070",
    "volume": "67",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-061-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "260",
    "z": "1070",
    "volume": "82",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-061-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "335",
    "z": "1070",
    "volume": "74",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-062-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "35",
    "z": "1070",
    "volume": "47",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-062-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "110",
    "z": "1070",
    "volume": "58",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-062-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "185",
    "z": "1070",
    "volume": "56",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-062-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "260",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-062-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "335",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-063-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "35",
    "z": "1070",
    "volume": "85",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-063-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "110",
    "z": "1070",
    "volume": "77",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-063-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "185",
    "z": "1070",
    "volume": "88",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-063-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "260",
    "z": "1070",
    "volume": "99",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-063-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "335",
    "z": "1070",
    "volume": "22",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-064-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "35",
    "z": "1070",
    "volume": "11",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-064-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "110",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-064-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "185",
    "z": "1070",
    "volume": "3",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-064-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "260",
    "z": "1070",
    "volume": "20",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-064-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "335",
    "z": "1070",
    "volume": "90",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-065-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "35",
    "z": "1070",
    "volume": "100",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-065-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "110",
    "z": "1070",
    "volume": "55",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-065-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "185",
    "z": "1070",
    "volume": "67",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-065-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "260",
    "z": "1070",
    "volume": "82",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-065-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "335",
    "z": "1070",
    "volume": "74",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-066-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "35",
    "z": "1070",
    "volume": "47",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-066-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "110",
    "z": "1070",
    "volume": "58",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-066-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "185",
    "z": "1070",
    "volume": "56",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-066-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "260",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-066-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "335",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-067-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "35",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-067-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "110",
    "z": "1070",
    "volume": "3",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-067-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "185",
    "z": "1070",
    "volume": "20",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-067-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "260",
    "z": "1070",
    "volume": "90",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-067-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "335",
    "z": "1070",
    "volume": "100",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-068-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "35",
    "z": "1070",
    "volume": "55",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-068-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "110",
    "z": "1070",
    "volume": "67",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-068-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "185",
    "z": "1070",
    "volume": "82",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-068-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "260",
    "z": "1070",
    "volume": "74",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-068-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "335",
    "z": "1070",
    "volume": "47",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-069-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "35",
    "z": "1070",
    "volume": "58",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-069-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "110",
    "z": "1070",
    "volume": "56",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-069-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "185",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-069-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "260",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-069-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "335",
    "z": "1070",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A07-070-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "35",
    "z": "1070",
    "volume": "3",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-070-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "110",
    "z": "1070",
    "volume": "20",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-070-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "185",
    "z": "1070",
    "volume": "90",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-070-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "260",
    "z": "1070",
    "volume": "100",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A07-070-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "335",
    "z": "1070",
    "volume": "55",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-001-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "35",
    "z": "1370",
    "volume": "67",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-001-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "110",
    "z": "1370",
    "volume": "82",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-001-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "185",
    "z": "1370",
    "volume": "74",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-001-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "260",
    "z": "1370",
    "volume": "47",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-001-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "0",
    "y": "335",
    "z": "1370",
    "volume": "58",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-002-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "35",
    "z": "1370",
    "volume": "56",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-002-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "110",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-002-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "185",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-002-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "260",
    "z": "1370",
    "volume": "23",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-002-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "55",
    "y": "335",
    "z": "1370",
    "volume": "77",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-003-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "35",
    "z": "1370",
    "volume": "88",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-003-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "110",
    "z": "1370",
    "volume": "99",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-003-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "185",
    "z": "1370",
    "volume": "22",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-003-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "260",
    "z": "1370",
    "volume": "11",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-003-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "110",
    "y": "335",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-004-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "35",
    "z": "1370",
    "volume": "3",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-004-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "110",
    "z": "1370",
    "volume": "20",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-004-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "185",
    "z": "1370",
    "volume": "90",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-004-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "260",
    "z": "1370",
    "volume": "100",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-004-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "165",
    "y": "335",
    "z": "1370",
    "volume": "55",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-005-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "35",
    "z": "1370",
    "volume": "67",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-005-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "110",
    "z": "1370",
    "volume": "82",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-005-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "185",
    "z": "1370",
    "volume": "74",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-005-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "260",
    "z": "1370",
    "volume": "47",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-005-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "220",
    "y": "335",
    "z": "1370",
    "volume": "58",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-006-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "35",
    "z": "1370",
    "volume": "56",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-006-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "110",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-006-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "185",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-006-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "260",
    "z": "1370",
    "volume": "63",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-006-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "275",
    "y": "335",
    "z": "1370",
    "volume": "77",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-007-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "35",
    "z": "1370",
    "volume": "88",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-007-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "110",
    "z": "1370",
    "volume": "99",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-007-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "185",
    "z": "1370",
    "volume": "22",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-007-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "260",
    "z": "1370",
    "volume": "11",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-007-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "330",
    "y": "335",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-008-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "35",
    "z": "1370",
    "volume": "3",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-008-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "110",
    "z": "1370",
    "volume": "20",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-008-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "185",
    "z": "1370",
    "volume": "90",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-008-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "260",
    "z": "1370",
    "volume": "100",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-008-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "385",
    "y": "335",
    "z": "1370",
    "volume": "55",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-009-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "35",
    "z": "1370",
    "volume": "67",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-009-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "110",
    "z": "1370",
    "volume": "82",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-009-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "185",
    "z": "1370",
    "volume": "74",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-009-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "260",
    "z": "1370",
    "volume": "47",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-009-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "440",
    "y": "335",
    "z": "1370",
    "volume": "58",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-010-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "35",
    "z": "1370",
    "volume": "56",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-010-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "110",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-010-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "185",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-010-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "260",
    "z": "1370",
    "volume": "85",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-010-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "495",
    "y": "335",
    "z": "1370",
    "volume": "77",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-011-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "35",
    "z": "1370",
    "volume": "88",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-011-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "110",
    "z": "1370",
    "volume": "99",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-011-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "185",
    "z": "1370",
    "volume": "22",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-011-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "260",
    "z": "1370",
    "volume": "11",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-011-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "550",
    "y": "335",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-012-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "35",
    "z": "1370",
    "volume": "3",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-012-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "110",
    "z": "1370",
    "volume": "20",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-012-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "185",
    "z": "1370",
    "volume": "90",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-012-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "260",
    "z": "1370",
    "volume": "100",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-012-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "605",
    "y": "335",
    "z": "1370",
    "volume": "55",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-013-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "35",
    "z": "1370",
    "volume": "67",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-013-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "110",
    "z": "1370",
    "volume": "82",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-013-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "185",
    "z": "1370",
    "volume": "74",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-013-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "260",
    "z": "1370",
    "volume": "47",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-013-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "660",
    "y": "335",
    "z": "1370",
    "volume": "58",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-014-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "35",
    "z": "1370",
    "volume": "56",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-014-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "110",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-014-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "185",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-014-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "260",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-014-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "715",
    "y": "335",
    "z": "1370",
    "volume": "3",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-015-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "35",
    "z": "1370",
    "volume": "20",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-015-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "110",
    "z": "1370",
    "volume": "90",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-015-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "185",
    "z": "1370",
    "volume": "100",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-015-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "260",
    "z": "1370",
    "volume": "55",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-015-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "770",
    "y": "335",
    "z": "1370",
    "volume": "67",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-016-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "35",
    "z": "1370",
    "volume": "82",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-016-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "110",
    "z": "1370",
    "volume": "74",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-016-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "185",
    "z": "1370",
    "volume": "47",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-016-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "260",
    "z": "1370",
    "volume": "58",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-016-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "825",
    "y": "335",
    "z": "1370",
    "volume": "56",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-017-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "35",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-017-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "110",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-017-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "185",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-017-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "260",
    "z": "1370",
    "volume": "3",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-017-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "880",
    "y": "335",
    "z": "1370",
    "volume": "20",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-018-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "35",
    "z": "1370",
    "volume": "90",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-018-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "110",
    "z": "1370",
    "volume": "100",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-018-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "185",
    "z": "1370",
    "volume": "55",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-018-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "260",
    "z": "1370",
    "volume": "67",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-018-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "935",
    "y": "335",
    "z": "1370",
    "volume": "82",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-019-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "35",
    "z": "1370",
    "volume": "74",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-019-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "110",
    "z": "1370",
    "volume": "47",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-019-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "185",
    "z": "1370",
    "volume": "58",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-019-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "260",
    "z": "1370",
    "volume": "56",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-019-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "990",
    "y": "335",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-020-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "35",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-020-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "110",
    "z": "1370",
    "volume": "23",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-020-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "185",
    "z": "1370",
    "volume": "77",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-020-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "260",
    "z": "1370",
    "volume": "88",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-020-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1045",
    "y": "335",
    "z": "1370",
    "volume": "99",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-021-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "35",
    "z": "1370",
    "volume": "22",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-021-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "110",
    "z": "1370",
    "volume": "11",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-021-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "185",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-021-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "260",
    "z": "1370",
    "volume": "3",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-021-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1100",
    "y": "335",
    "z": "1370",
    "volume": "20",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-022-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "35",
    "z": "1370",
    "volume": "90",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-022-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "110",
    "z": "1370",
    "volume": "100",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-022-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "185",
    "z": "1370",
    "volume": "55",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-022-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "260",
    "z": "1370",
    "volume": "67",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-022-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1155",
    "y": "335",
    "z": "1370",
    "volume": "82",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-023-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "35",
    "z": "1370",
    "volume": "74",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-023-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "110",
    "z": "1370",
    "volume": "47",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-023-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "185",
    "z": "1370",
    "volume": "58",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-023-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "260",
    "z": "1370",
    "volume": "56",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-023-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1210",
    "y": "335",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-024-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "35",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-024-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "110",
    "z": "1370",
    "volume": "63",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-024-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "185",
    "z": "1370",
    "volume": "77",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-024-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "260",
    "z": "1370",
    "volume": "88",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-024-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1265",
    "y": "335",
    "z": "1370",
    "volume": "99",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-025-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "35",
    "z": "1370",
    "volume": "22",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-025-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "110",
    "z": "1370",
    "volume": "11",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-025-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "185",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-025-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "260",
    "z": "1370",
    "volume": "3",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-025-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1320",
    "y": "335",
    "z": "1370",
    "volume": "20",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-026-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "35",
    "z": "1370",
    "volume": "90",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-026-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "110",
    "z": "1370",
    "volume": "100",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-026-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "185",
    "z": "1370",
    "volume": "55",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-026-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "260",
    "z": "1370",
    "volume": "67",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-026-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1375",
    "y": "335",
    "z": "1370",
    "volume": "82",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-027-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "35",
    "z": "1370",
    "volume": "74",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-027-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "110",
    "z": "1370",
    "volume": "47",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-027-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "185",
    "z": "1370",
    "volume": "58",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-027-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "260",
    "z": "1370",
    "volume": "56",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-027-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1430",
    "y": "335",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-028-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "35",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-028-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "110",
    "z": "1370",
    "volume": "85",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-028-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "185",
    "z": "1370",
    "volume": "77",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-028-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "260",
    "z": "1370",
    "volume": "88",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-028-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1485",
    "y": "335",
    "z": "1370",
    "volume": "99",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-029-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "35",
    "z": "1370",
    "volume": "22",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-029-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "110",
    "z": "1370",
    "volume": "11",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-029-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "185",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-029-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "260",
    "z": "1370",
    "volume": "3",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-029-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1540",
    "y": "335",
    "z": "1370",
    "volume": "20",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-030-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "35",
    "z": "1370",
    "volume": "90",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-030-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "110",
    "z": "1370",
    "volume": "100",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-030-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "185",
    "z": "1370",
    "volume": "55",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-030-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "260",
    "z": "1370",
    "volume": "67",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-030-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1595",
    "y": "335",
    "z": "1370",
    "volume": "82",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-031-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "35",
    "z": "1370",
    "volume": "74",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-031-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "110",
    "z": "1370",
    "volume": "47",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-031-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "185",
    "z": "1370",
    "volume": "58",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-031-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "260",
    "z": "1370",
    "volume": "56",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-031-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1650",
    "y": "335",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-032-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "35",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-032-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "110",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-032-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "185",
    "z": "1370",
    "volume": "3",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-032-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "260",
    "z": "1370",
    "volume": "20",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-032-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1705",
    "y": "335",
    "z": "1370",
    "volume": "90",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-033-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "35",
    "z": "1370",
    "volume": "100",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-033-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "110",
    "z": "1370",
    "volume": "55",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-033-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "185",
    "z": "1370",
    "volume": "67",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-033-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "260",
    "z": "1370",
    "volume": "82",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-033-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1760",
    "y": "335",
    "z": "1370",
    "volume": "74",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-034-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "35",
    "z": "1370",
    "volume": "47",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-034-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "110",
    "z": "1370",
    "volume": "58",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-034-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "185",
    "z": "1370",
    "volume": "56",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-034-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "260",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-034-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1815",
    "y": "335",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-035-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "35",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-035-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "110",
    "z": "1370",
    "volume": "3",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-035-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "185",
    "z": "1370",
    "volume": "20",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-035-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "260",
    "z": "1370",
    "volume": "90",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-035-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1870",
    "y": "335",
    "z": "1370",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-036-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "35",
    "z": "1370",
    "volume": "55",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-036-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "110",
    "z": "1370",
    "volume": "67",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-036-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "185",
    "z": "1370",
    "volume": "82",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-036-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "260",
    "z": "1370",
    "volume": "74",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-036-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1925",
    "y": "335",
    "z": "1370",
    "volume": "47",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-037-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "35",
    "z": "1370",
    "volume": "58",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-037-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "110",
    "z": "1370",
    "volume": "56",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-037-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "185",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-037-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "260",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-037-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "1980",
    "y": "335",
    "z": "1370",
    "volume": "23",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-038-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "35",
    "z": "1370",
    "volume": "77",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-038-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "110",
    "z": "1370",
    "volume": "88",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-038-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "185",
    "z": "1370",
    "volume": "99",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-038-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "260",
    "z": "1370",
    "volume": "22",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-038-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2035",
    "y": "335",
    "z": "1370",
    "volume": "11",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-039-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "35",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-039-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "110",
    "z": "1370",
    "volume": "3",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-039-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "185",
    "z": "1370",
    "volume": "20",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-039-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "260",
    "z": "1370",
    "volume": "90",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-039-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2090",
    "y": "335",
    "z": "1370",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-040-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "35",
    "z": "1370",
    "volume": "55",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-040-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "110",
    "z": "1370",
    "volume": "67",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-040-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "185",
    "z": "1370",
    "volume": "82",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-040-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "260",
    "z": "1370",
    "volume": "74",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-040-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2145",
    "y": "335",
    "z": "1370",
    "volume": "47",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-041-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "35",
    "z": "1370",
    "volume": "58",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-041-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "110",
    "z": "1370",
    "volume": "56",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-041-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "185",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-041-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "260",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-041-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2200",
    "y": "335",
    "z": "1370",
    "volume": "63",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-042-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "35",
    "z": "1370",
    "volume": "77",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-042-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "110",
    "z": "1370",
    "volume": "88",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-042-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "185",
    "z": "1370",
    "volume": "99",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-042-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "260",
    "z": "1370",
    "volume": "22",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-042-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2255",
    "y": "335",
    "z": "1370",
    "volume": "11",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-043-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "35",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-043-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "110",
    "z": "1370",
    "volume": "3",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-043-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "185",
    "z": "1370",
    "volume": "20",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-043-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "260",
    "z": "1370",
    "volume": "90",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-043-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2310",
    "y": "335",
    "z": "1370",
    "volume": "100",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-044-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "35",
    "z": "1370",
    "volume": "55",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-044-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "110",
    "z": "1370",
    "volume": "67",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-044-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "185",
    "z": "1370",
    "volume": "82",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-044-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "260",
    "z": "1370",
    "volume": "74",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-044-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2365",
    "y": "335",
    "z": "1370",
    "volume": "47",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-045-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "35",
    "z": "1370",
    "volume": "58",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-045-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "110",
    "z": "1370",
    "volume": "56",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-045-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "185",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-045-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "260",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-045-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2420",
    "y": "335",
    "z": "1370",
    "volume": "85",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-046-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "35",
    "z": "1370",
    "volume": "77",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-046-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "110",
    "z": "1370",
    "volume": "88",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-046-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "185",
    "z": "1370",
    "volume": "99",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-046-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "260",
    "z": "1370",
    "volume": "22",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-046-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2475",
    "y": "335",
    "z": "1370",
    "volume": "11",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-047-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "35",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-047-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "110",
    "z": "1370",
    "volume": "3",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-047-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "185",
    "z": "1370",
    "volume": "20",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-047-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "260",
    "z": "1370",
    "volume": "90",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-047-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2530",
    "y": "335",
    "z": "1370",
    "volume": "100",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-048-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "35",
    "z": "1370",
    "volume": "55",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-048-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "110",
    "z": "1370",
    "volume": "67",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-048-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "185",
    "z": "1370",
    "volume": "82",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-048-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "260",
    "z": "1370",
    "volume": "74",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-048-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2585",
    "y": "335",
    "z": "1370",
    "volume": "47",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-049-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "35",
    "z": "1370",
    "volume": "58",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-049-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "110",
    "z": "1370",
    "volume": "56",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-049-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "185",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-049-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "260",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-049-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2640",
    "y": "335",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-050-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "35",
    "z": "1370",
    "volume": "3",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-050-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "110",
    "z": "1370",
    "volume": "20",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-050-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "185",
    "z": "1370",
    "volume": "90",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-050-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "260",
    "z": "1370",
    "volume": "100",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-050-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2695",
    "y": "335",
    "z": "1370",
    "volume": "55",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-051-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "35",
    "z": "1370",
    "volume": "67",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-051-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "110",
    "z": "1370",
    "volume": "82",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-051-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "185",
    "z": "1370",
    "volume": "74",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-051-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "260",
    "z": "1370",
    "volume": "47",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-051-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2750",
    "y": "335",
    "z": "1370",
    "volume": "58",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-052-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "35",
    "z": "1370",
    "volume": "56",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-052-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "110",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-052-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "185",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-052-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "260",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-052-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2805",
    "y": "335",
    "z": "1370",
    "volume": "3",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-053-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "35",
    "z": "1370",
    "volume": "20",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-053-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "110",
    "z": "1370",
    "volume": "90",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-053-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "185",
    "z": "1370",
    "volume": "100",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-053-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "260",
    "z": "1370",
    "volume": "55",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-053-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2860",
    "y": "335",
    "z": "1370",
    "volume": "67",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-054-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "35",
    "z": "1370",
    "volume": "82",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-054-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "110",
    "z": "1370",
    "volume": "74",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-054-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "185",
    "z": "1370",
    "volume": "47",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-054-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "260",
    "z": "1370",
    "volume": "58",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-054-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2915",
    "y": "335",
    "z": "1370",
    "volume": "56",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-055-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "35",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-055-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "110",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-055-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "185",
    "z": "1370",
    "volume": "23",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-055-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "260",
    "z": "1370",
    "volume": "77",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-055-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "2970",
    "y": "335",
    "z": "1370",
    "volume": "88",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-056-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "35",
    "z": "1370",
    "volume": "99",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-056-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "110",
    "z": "1370",
    "volume": "22",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-056-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "185",
    "z": "1370",
    "volume": "11",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-056-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "260",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-056-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3025",
    "y": "335",
    "z": "1370",
    "volume": "3",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-057-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "35",
    "z": "1370",
    "volume": "20",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-057-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "110",
    "z": "1370",
    "volume": "90",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-057-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "185",
    "z": "1370",
    "volume": "100",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-057-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "260",
    "z": "1370",
    "volume": "55",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-057-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3080",
    "y": "335",
    "z": "1370",
    "volume": "67",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-058-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "35",
    "z": "1370",
    "volume": "82",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-058-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "110",
    "z": "1370",
    "volume": "74",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-058-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "185",
    "z": "1370",
    "volume": "47",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-058-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "260",
    "z": "1370",
    "volume": "58",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-058-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3135",
    "y": "335",
    "z": "1370",
    "volume": "56",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-059-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "35",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-059-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "110",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-059-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "185",
    "z": "1370",
    "volume": "63",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-059-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "260",
    "z": "1370",
    "volume": "77",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-059-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3190",
    "y": "335",
    "z": "1370",
    "volume": "88",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-060-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "35",
    "z": "1370",
    "volume": "99",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-060-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "110",
    "z": "1370",
    "volume": "22",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-060-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "185",
    "z": "1370",
    "volume": "11",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-060-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "260",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-060-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3245",
    "y": "335",
    "z": "1370",
    "volume": "3",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-061-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "35",
    "z": "1370",
    "volume": "20",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-061-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "110",
    "z": "1370",
    "volume": "90",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-061-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "185",
    "z": "1370",
    "volume": "100",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-061-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "260",
    "z": "1370",
    "volume": "55",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-061-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3300",
    "y": "335",
    "z": "1370",
    "volume": "67",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-062-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "35",
    "z": "1370",
    "volume": "82",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-062-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "110",
    "z": "1370",
    "volume": "74",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-062-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "185",
    "z": "1370",
    "volume": "47",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-062-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "260",
    "z": "1370",
    "volume": "58",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-062-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3355",
    "y": "335",
    "z": "1370",
    "volume": "56",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-063-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "35",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-063-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "110",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-063-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "185",
    "z": "1370",
    "volume": "85",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-063-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "260",
    "z": "1370",
    "volume": "77",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-063-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3410",
    "y": "335",
    "z": "1370",
    "volume": "88",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-064-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "35",
    "z": "1370",
    "volume": "99",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-064-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "110",
    "z": "1370",
    "volume": "22",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-064-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "185",
    "z": "1370",
    "volume": "11",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-064-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "260",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-064-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3465",
    "y": "335",
    "z": "1370",
    "volume": "3",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-065-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "35",
    "z": "1370",
    "volume": "20",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-065-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "110",
    "z": "1370",
    "volume": "90",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-065-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "185",
    "z": "1370",
    "volume": "100",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-065-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "260",
    "z": "1370",
    "volume": "55",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-065-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3520",
    "y": "335",
    "z": "1370",
    "volume": "67",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-066-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "35",
    "z": "1370",
    "volume": "82",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-066-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "110",
    "z": "1370",
    "volume": "74",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-066-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "185",
    "z": "1370",
    "volume": "47",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-066-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "260",
    "z": "1370",
    "volume": "58",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-066-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3575",
    "y": "335",
    "z": "1370",
    "volume": "56",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-067-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "35",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-067-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "110",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-067-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "185",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-067-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "260",
    "z": "1370",
    "volume": "3",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-067-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3630",
    "y": "335",
    "z": "1370",
    "volume": "20",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-068-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "35",
    "z": "1370",
    "volume": "90",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-068-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "110",
    "z": "1370",
    "volume": "100",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-068-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "185",
    "z": "1370",
    "volume": "55",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-068-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "260",
    "z": "1370",
    "volume": "67",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-068-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3685",
    "y": "335",
    "z": "1370",
    "volume": "82",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-069-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "35",
    "z": "1370",
    "volume": "74",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-069-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "110",
    "z": "1370",
    "volume": "47",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-069-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "185",
    "z": "1370",
    "volume": "58",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-069-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "260",
    "z": "1370",
    "volume": "56",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-069-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3740",
    "y": "335",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "A08-070-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "35",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-070-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "110",
    "z": "1370",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-070-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "185",
    "z": "1370",
    "volume": "3",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-070-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "260",
    "z": "1370",
    "volume": "20",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "A08-070-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "3795",
    "y": "335",
    "z": "1370",
    "volume": "90",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-001-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "0",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-001-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "0",
    "volume": "55",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-001-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "0",
    "volume": "67",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-001-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "0",
    "volume": "82",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-001-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "0",
    "volume": "74",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-002-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "55",
    "volume": "47",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-002-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "55",
    "volume": "58",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-002-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "55",
    "volume": "56",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-002-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "55",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-002-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "55",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-003-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "110",
    "volume": "23",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-003-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "110",
    "volume": "77",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-003-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "110",
    "volume": "88",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-003-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "110",
    "volume": "99",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-003-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "110",
    "volume": "22",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-004-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "165",
    "volume": "11",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-004-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "165",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-004-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "165",
    "volume": "3",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-004-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "165",
    "volume": "20",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-004-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "165",
    "volume": "90",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-005-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "220",
    "volume": "100",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-005-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "220",
    "volume": "55",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-005-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "220",
    "volume": "67",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-005-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "220",
    "volume": "82",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-005-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "220",
    "volume": "74",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-006-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "275",
    "volume": "47",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-006-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "275",
    "volume": "58",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-006-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "275",
    "volume": "56",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-006-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "275",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-006-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "275",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-007-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "330",
    "volume": "63",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-007-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "330",
    "volume": "77",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-007-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "330",
    "volume": "88",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-007-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "330",
    "volume": "99",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-007-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "330",
    "volume": "22",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-008-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "385",
    "volume": "11",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-008-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "385",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-008-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "385",
    "volume": "3",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-008-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "385",
    "volume": "20",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-008-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "385",
    "volume": "90",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-009-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "440",
    "volume": "100",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-009-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "440",
    "volume": "55",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-009-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "440",
    "volume": "67",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-009-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "440",
    "volume": "82",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-009-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "440",
    "volume": "74",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-010-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "495",
    "volume": "47",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-010-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "495",
    "volume": "58",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-010-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "495",
    "volume": "56",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-010-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "495",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-010-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "495",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-011-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "550",
    "volume": "85",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-011-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "550",
    "volume": "77",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-011-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "550",
    "volume": "88",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-011-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "550",
    "volume": "99",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-011-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "550",
    "volume": "22",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-012-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "605",
    "volume": "11",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-012-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "605",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-012-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "605",
    "volume": "3",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-012-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "605",
    "volume": "20",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-012-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "605",
    "volume": "90",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-013-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "660",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-013-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "660",
    "volume": "55",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-013-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "660",
    "volume": "67",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-013-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "660",
    "volume": "82",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-013-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "660",
    "volume": "74",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-014-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "715",
    "volume": "47",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-014-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "715",
    "volume": "58",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-014-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "715",
    "volume": "56",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-014-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "715",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-014-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "715",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-015-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "770",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-015-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "770",
    "volume": "3",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-015-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "770",
    "volume": "20",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-015-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "770",
    "volume": "90",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-015-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "770",
    "volume": "100",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-016-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "825",
    "volume": "55",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-016-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "825",
    "volume": "67",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-016-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "825",
    "volume": "82",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-016-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "825",
    "volume": "74",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-016-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "825",
    "volume": "47",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-017-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "880",
    "volume": "58",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-017-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "880",
    "volume": "56",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-017-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "880",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-017-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "880",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-017-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "880",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-018-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "935",
    "volume": "3",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-018-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "935",
    "volume": "20",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-018-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "935",
    "volume": "90",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-018-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "935",
    "volume": "100",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-018-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "935",
    "volume": "55",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-019-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "990",
    "volume": "67",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-019-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "990",
    "volume": "82",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-019-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "990",
    "volume": "74",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-019-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "990",
    "volume": "47",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-019-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "990",
    "volume": "58",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-020-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "1045",
    "volume": "56",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-020-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "1045",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-020-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "1045",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-020-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "1045",
    "volume": "23",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-020-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "1045",
    "volume": "77",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-021-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "1100",
    "volume": "88",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-021-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "1100",
    "volume": "99",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-021-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "1100",
    "volume": "22",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-021-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "1100",
    "volume": "11",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-021-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "1100",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-022-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "1155",
    "volume": "3",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-022-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "1155",
    "volume": "20",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-022-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "1155",
    "volume": "90",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-022-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "1155",
    "volume": "100",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-022-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "1155",
    "volume": "55",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-023-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "1210",
    "volume": "67",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-023-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "1210",
    "volume": "82",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-023-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "1210",
    "volume": "74",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-023-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "1210",
    "volume": "47",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-023-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "1210",
    "volume": "58",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-024-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "1265",
    "volume": "56",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-024-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "1265",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-024-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "1265",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-024-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "1265",
    "volume": "63",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-024-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "1265",
    "volume": "77",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-025-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "1320",
    "volume": "88",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-025-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "1320",
    "volume": "99",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-025-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "1320",
    "volume": "22",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-025-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "1320",
    "volume": "11",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-025-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "1320",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-026-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "1375",
    "volume": "3",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-026-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "1375",
    "volume": "20",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-026-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "1375",
    "volume": "90",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-026-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "1375",
    "volume": "100",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-026-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "1375",
    "volume": "55",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-027-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "1430",
    "volume": "67",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-027-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "1430",
    "volume": "82",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-027-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "1430",
    "volume": "74",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-027-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "1430",
    "volume": "47",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-027-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "1430",
    "volume": "58",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-028-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "1485",
    "volume": "56",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-028-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "1485",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-028-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "1485",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-028-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "1485",
    "volume": "85",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-028-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "1485",
    "volume": "77",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-029-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "1540",
    "volume": "88",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-029-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "1540",
    "volume": "99",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-029-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "1540",
    "volume": "22",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-029-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "1540",
    "volume": "11",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-029-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "1540",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-030-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "1595",
    "volume": "3",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-030-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "1595",
    "volume": "20",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-030-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "1595",
    "volume": "90",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-030-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "1595",
    "volume": "100",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-030-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "1595",
    "volume": "55",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-031-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "1650",
    "volume": "67",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-031-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "1650",
    "volume": "82",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-031-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "1650",
    "volume": "74",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-031-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "1650",
    "volume": "47",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-031-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "1650",
    "volume": "58",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-032-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "1705",
    "volume": "56",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-032-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "1705",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-032-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "1705",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-032-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "1705",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-032-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "1705",
    "volume": "3",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-033-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "1760",
    "volume": "20",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-033-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "1760",
    "volume": "90",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-033-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "1760",
    "volume": "100",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-033-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "1760",
    "volume": "55",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-033-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "1760",
    "volume": "67",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-034-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "1815",
    "volume": "82",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-034-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "1815",
    "volume": "74",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-034-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "1815",
    "volume": "47",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-034-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "1815",
    "volume": "58",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-034-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "1815",
    "volume": "56",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-035-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "1870",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-035-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "1870",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-035-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "1870",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-035-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "1870",
    "volume": "3",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-035-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "1870",
    "volume": "20",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-036-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "1925",
    "volume": "90",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-036-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "1925",
    "volume": "100",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-036-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "1925",
    "volume": "55",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-036-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "1925",
    "volume": "67",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-036-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "1925",
    "volume": "82",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-037-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "1980",
    "volume": "74",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-037-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "1980",
    "volume": "47",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-037-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "1980",
    "volume": "58",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-037-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "1980",
    "volume": "56",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-037-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "1980",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-038-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "2035",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-038-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "2035",
    "volume": "23",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-038-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "2035",
    "volume": "77",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-038-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "2035",
    "volume": "88",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-038-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "2035",
    "volume": "99",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-039-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "2090",
    "volume": "22",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-039-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "2090",
    "volume": "11",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-039-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "2090",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-039-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "2090",
    "volume": "3",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-039-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "2090",
    "volume": "20",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-040-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "2145",
    "volume": "90",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-040-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "2145",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-040-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "2145",
    "volume": "55",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-040-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "2145",
    "volume": "67",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-040-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "2145",
    "volume": "82",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-041-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "2200",
    "volume": "74",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-041-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "2200",
    "volume": "47",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-041-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "2200",
    "volume": "58",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-041-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "2200",
    "volume": "56",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-041-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "2200",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-042-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "2255",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-042-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "2255",
    "volume": "63",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-042-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "2255",
    "volume": "77",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-042-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "2255",
    "volume": "88",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-042-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "2255",
    "volume": "99",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-043-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "2310",
    "volume": "22",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-043-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "2310",
    "volume": "11",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-043-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "2310",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-043-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "2310",
    "volume": "3",
    "Item": "Whole Milk 1 Gallon Jug"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-043-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "2310",
    "volume": "20",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-044-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "2365",
    "volume": "90",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-044-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "2365",
    "volume": "100",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-044-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "2365",
    "volume": "55",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-044-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "2365",
    "volume": "67",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-044-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "2365",
    "volume": "82",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-045-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "2420",
    "volume": "74",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-045-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "2420",
    "volume": "47",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-045-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "2420",
    "volume": "58",
    "Item": "Long Grain White Rice 5 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-045-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "2420",
    "volume": "56",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-045-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "2420",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-046-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "2475",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-046-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "2475",
    "volume": "85",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-046-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "2475",
    "volume": "77",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-046-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "2475",
    "volume": "88",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-046-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "2475",
    "volume": "99",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-047-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "2530",
    "volume": "22",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-047-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "2530",
    "volume": "11",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-047-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "2530",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-047-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "2530",
    "volume": "3",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-047-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "2530",
    "volume": "20",
    "Item": "Spaghetti Pasta 16 oz Box"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-048-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "2585",
    "volume": "90",
    "Item": "Gala Apples 3 lb Bag"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-048-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "2585",
    "volume": "100",
    "Item": "Coca-Cola"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-048-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "2585",
    "volume": "55",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-048-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "2585",
    "volume": "67",
    "Item": "Large Eggs 12 Count Carton"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-048-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "2585",
    "volume": "82",
    "Item": "Salted Butter 16 oz (4 Sticks)"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-049-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "2640",
    "volume": "74",
    "Item": "Boneless Skinless Chicken Breast 2 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-049-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "2640",
    "volume": "47",
    "Item": "White Sandwich Bread 20 oz Loaf"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-049-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "2640",
    "volume": "58",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-049-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "2640",
    "volume": "56",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-049-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "2640",
    "volume": "0"
  },
  {
    "arecod": "GROUND",
    "stoloc": "B01-050-01",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "35",
    "z": "2695",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-050-02",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "110",
    "z": "2695",
    "volume": "0"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-050-03",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "185",
    "z": "2695",
    "volume": "3",
    "Item": "Roma Tomatoes 1 lb Pack"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-050-04",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "260",
    "z": "2695",
    "volume": "20",
    "Item": "Cheddar Cheese 8 oz Block"
  },
  {
    "arecod": "RACK",
    "stoloc": "B01-050-05",
    "loclen": "42",
    "locwid": "48",
    "lochgt": "65",
    "x": "4200",
    "y": "335",
    "z": "2695",
    "volume": "90",
    "Item": "Roma Tomatoes 1 lb Pack"
  }
]